(function () {
  "use strict";

  // what the 3D server encrypts the preview file with (server.py OUTPUT_CIPHER)
  var MODEL_CIPHER = "aes-ctr-1";

  var PAYLOAD_KEYS = [
    "sport",
    "model",
    "design",
    "name",
    "back_text",
    "text_02",
    "font",
    "text_main_color",
    "outline1_color",
    "outline2_color",
    "text_02_main_color",
    "text_02_outline1_color",
    "text_02_outline2_color",
    "back_text_color",
    "back_ball_color",
    "ball_color",
    "stitches_color"
  ];
  var COLOR_KEYS = [
    "text_main_color",
    "outline1_color",
    "outline2_color",
    "text_02_main_color",
    "text_02_outline1_color",
    "text_02_outline2_color",
    "back_text_color",
    "back_ball_color",
    "ball_color",
    "stitches_color"
  ];
  var NON_COLOR_KEYS = ["sport", "design", "name", "back_text", "text_02", "font", "team_names"];
  var MATERIAL_COLOR_MAP = {
    text_main_color: "MAT_TEXT_MAIN",
    outline1_color: "MAT_TEXT_OUTLINE_1",
    outline2_color: "MAT_TEXT_OUTLINE_2",
    text_02_main_color: "MAT_TEXT_02_MAIN",
    text_02_outline1_color: "MAT_TEXT_02_OUTLINE_1",
    text_02_outline2_color: "MAT_TEXT_02_OUTLINE_2",
    back_text_color: "MAT_TEXT_BACK",
    back_ball_color: "MAT_BACK_BALL",
    ball_color: "MAT_BALL",
    stitches_color: "MAT_STITCHES"
  };

  function isTextPayloadKey(key) {
    var raw = String(key || "").trim();
    return raw === "name" || raw === "back_text" || /^text_\d{2}$/.test(raw);
  }

  function appendUnique(out, key) {
    var raw = String(key || "").trim();
    if (raw && out.indexOf(raw) === -1) out.push(raw);
  }

  function collectPayloadKeys(config) {
    var out = PAYLOAD_KEYS.slice();
    function scanMap(map) {
      if (!map || typeof map !== "object") return;
      Object.keys(map).forEach(function (key) {
        if (isTextPayloadKey(key)) appendUnique(out, key);
      });
    }
    scanMap(config && config.defaults);
    scanMap(config && config.fields);
    var sports = (config && config.sports && typeof config.sports === "object") ? config.sports : {};
    Object.keys(sports).forEach(function (sportKey) {
      var sportCfg = sports[sportKey] || {};
      scanMap(sportCfg.defaults);
      scanMap(sportCfg.fields);
    });
    return out;
  }

  function collectPayloadKeysFromPayload(payload) {
    var out = PAYLOAD_KEYS.slice();
    Object.keys(payload || {}).sort().forEach(function (key) {
      if (key !== "team_names") appendUnique(out, key);
    });
    return out;
  }

  function collectGeometryKeys(payload) {
    var out = NON_COLOR_KEYS.slice();
    Object.keys(payload || {}).sort().forEach(function (key) {
      if (COLOR_KEYS.indexOf(key) === -1) appendUnique(out, key);
    });
    return out;
  }

  var DEFAULT_CONFIG = {
    apiUrl: "https://preview.sportify3d.com/preview",
    viewerSelector: "#sp3d-viewer",
    statusSelector: "#sp3d-status",
    updateButtonSelector: "#sp3d-update-btn",
    initialDelayMs: 300,
    autoUpdate: true,
    autoUpdateEvents: {
      input: true,
      change: true,
      click: false
    },
    observeDom: false,
    debounceMs: {
      text: 350,
      choice: 90
    },
    teamPreview: {
      enabled: true,
      groupNames: ["Groupe Enter your team names"],
      groupMatchMode: "exact",
      preferFirstMatchingGroup: true,
      maxNames: 50,
      fieldNameRegex: "^name[:_\\- ]?\\d+$",
      fallbackMatchNameFields: false
    },
    viewerFraming: {
      cameraTarget: "auto auto auto",
      desktopOrbit: "0deg 20deg 84%",
      mobileOrbit: "0deg 20deg 84%",
      minOrbit: "auto auto 80%",
      maxOrbit: "auto auto 96%",
      lockVerticalAngleDeg: 0,
      dynamicZoom: {
        enabled: true,
        startAtName: 2,
        singleNameRadiusDesktopPercent: 92,
        singleNameRadiusMobilePercent: 92,
        perExtraNameDesktopPercent: 11,
        perExtraNameMobilePercent: 16,
        maxExtraPercent: 170,
        minRadiusDesktopPercent: 84,
        minRadiusMobilePercent: 84,
        maxRadiusDesktopPercent: 280,
        maxRadiusMobilePercent: 320,
        radiusWindowPercent: 22
      },
      autoRotateLimited: {
        enabled: true,
        speedDegPerSec: 10,
        minAzimuthDeg: -35,
        maxAzimuthDeg: 35,
        pauseOnInteractionMs: 1200
      },
      minFieldOfView: "14deg",
      maxFieldOfView: "24deg"
    },
    ui: {
      subtitle: "",
      compactMode: false,
      showAddToCartButton: true,
      clickthrough: {
        url: "",
        buttonLabel: "Open link",
        newTab: false,
        showButton: false,
        clickableCard: false
      },
      viewerWindow: {
        desktopHeightPx: 220,
        mobileHeightPx: 170,
        minHeightPx: 120,
        maxHeightPx: 520,
        dynamicByNames: {
          enabled: false,
          nhlOnly: false,
          perNamePx: 8,
          startAtName: 2
        }
      }
    },
    limits: {
      name: 16,
      back_text: 16,
      text_02: 16
    },
    strictSportAllowlist: false,
    allowedSports: ["baseball", "basketball", "softball", "hockey", "soccer", "football", "nhl", "shield", "lacrosse"],
    sportAliases: {
      baseball: "baseball",
      softball: "softball",
      basketball: "basketball",
      hockey: "hockey",
      nhl: "hockey",
      "hockey nhl": "hockey",
      "nhl hockey": "hockey",
      soccer: "soccer",
      football: "football",
      lacrosse: "lacrosse",
      shield: "shield",
      soccer_women: "soccer_women",
      "soccer women": "soccer_women",
      "soccer feminin": "soccer_women",
      "soccer féminin": "soccer_women",
      "soccer feminine": "soccer_women",
      "soccer féminine": "soccer_women",
      "field hockey": "field_hockey",
      "hockey sur gazon": "field_hockey",
      "karaté": "karate",
      quilles: "bowling",
      billard: "pool",
      billiard: "pool",
      bouclier: "shield",
      "écusson": "shield",
      ecusson: "shield"
    },
    allowedFonts: ["sporty", "curvy", "wild", "krt", "block", "kalam"],
    fontAliases: {
      sporty: "sporty",
      sportify3d: "sporty",
      athletic: "sporty",
      block: "block",
      curvy: "curvy",
      script: "curvy",
      cursive: "curvy",
      wild: "wild",
      wildcat: "wild",
      krt: "krt",
      shuriken: "krt",
      kalam: "kalam",
      manuscrit: "kalam",
      handwritten: "kalam"
    },
    colorAliases: {
      black: "#000000",
      bk: "#000000",
      white: "#FFFFFF",
      wh: "#FFFFFF",
      blue: "#0001FF",
      bl: "#0001FF",
      red: "#FF0000",
      rd: "#FF0000",
      yellow: "#FDFD01",
      yw: "#FDFD01",
      "blue navy": "#000047",
      "navy blue": "#000047",
      bny: "#000047",
      "light blue": "#48BFD6",
      lbl: "#48BFD6",
      green: "#03FE00",
      gn: "#03FE00",
      orange: "#FF6A14",
      ora: "#FF6A14",
      pink: "#FF8080",
      pk: "#FF8080",
      purple: "#800080",
      gold: "#E4AE3C",
      gd: "#E4AE3C",
      silver: "#D5BDBC",
      "sparkling pink": "#FFA3D4",
      spk: "#FFA3D4",
      "blue jean": "#0097B2",
      bj: "#0097B2",
      "iron gray": "#43403D",
      gray: "#BBBBBB",
      brown: "#B2935B",
      turquoise: "#3ECDBE"
    },
    allowedColors: [],
    defaults: {
      sport: "baseball",
      design: "tag",
      name: "PREVIEW",
      back_text: "",
      text_02: "",
      text_03: "",
      text_04: "",
      font: "sporty",
      text_main_color: "#0001FF",
      outline1_color: "#FFFFFF",
      outline2_color: "#000000",
      text_02_main_color: "#0001FF",
      text_02_outline1_color: "#FFFFFF",
      text_02_outline2_color: "#000000",
      back_text_color: "#000000",
      back_ball_color: "#000000",
      ball_color: "#FFFFFF",
      stitches_color: "#FF0000"
    },
    variantSportOptionName: "Sport",
    variantFieldSelectors: [
      "input[name^='options[']:checked",
      "select[name^='options[']",
      "variant-selects input[type='radio']:checked",
      "variant-selects select",
      ".product-form__input input[type='radio']:checked",
      ".product-form__input select"
    ],
    productTypeToSport: {
      tag: "baseball"
    },
    useMetafieldPreset: false,
    presets: {},
    productTypes: {
      tag: {
        defaultPreset: { sport: "baseball", design: "tag" }
      },
      nameplate: {
        defaultPreset: { sport: "baseball", design: "nameplate" },
        presetBySport: {
          hockey: { sport: "hockey", design: "nameplate" },
          nhl: { sport: "hockey", design: "nameplate" }
        }
      },
      medal: {
        defaultPreset: { sport: "baseball", design: "medal" }
      }
    },
    productTypeToPreset: {
      tag: { sport: "baseball", design: "tag" },
      nameplate: { sport: "baseball", design: "nameplate" },
      medal: { sport: "baseball", design: "medal" }
    },
    products: {
      nameplate: {
        defaultPreset: { sport: "baseball", design: "nameplate" },
        presetBySport: {
          hockey: { sport: "hockey", design: "nameplate" },
          nhl: { sport: "hockey", design: "nameplate" }
        }
      },
      "custom-tag-builder": { sport: "baseball", design: "tag" },
      "custom-tag-builder-fundraiser": { sport: "baseball", design: "tag" }
    },
    sport: "baseball",
    sports: {
      baseball: {
        defaults: {
          ball_color: "#FFFFFF",
          stitches_color: "#ff0000"
        },
        fields: {
          variant_sport: [
            "input[name='options[Sport]']:checked",
            "select[name='options[Sport]']",
            "[name='options[Sport]']"
          ],
          sport_option: ["[name='properties[Sport]']"],
          design: ["[name='properties[Design]']", "[name='properties[Model]']"],
          name: ["#sp3d-name", "[name='properties[Name]']", "[name='properties[Name:]']"],
          name_1: ["[name='properties[Name:_1]']", "[name='properties[Name_1]']", "[name='properties[name_1]']"],
          text_02: ["#sp3d-text-02", "[name='properties[Second Row text]']"],
          text_03: ["#sp3d-text-03", "[name='properties[Third Row text]']"],
          text_04: ["#sp3d-text-04", "[name='properties[Fourth Row text]']"],
          back_text: ["#sp3d-back-text", "[name='properties[Back Text]']"],
          font: ["[name='properties[Font]']"],
          colors_mode: ["[name='properties[Classic Colors]']"],
          classic_colors: ["[name='properties[Classic Colors]']"],
          text_main_color: ["[name='properties[Color1]']", "[name='properties[Main text Color]']"],
          outline1_color: ["[name='properties[Outline1]']", "[name='properties[Outline#1]']"],
          outline2_color: ["[name='properties[Outline2]']", "[name='properties[Outline#2]']"],
          text_02_main_color: ["[name='properties[Second Row Color]']", "[name='properties[Top Text Color]']"],
          text_02_outline1_color: ["[name='properties[Second Row Outline1]']"],
          text_02_outline2_color: ["[name='properties[Second Row Outline2]']"],
          back_text_color: ["[name='properties[Back Text Color]']"],
          back_ball_color: ["[name='properties[Back Ball]']"],
          ball_color: ["[name='properties[Ball]']"],
          stitches_color: ["[name='properties[Stitches]']"]
        }
      },
      basketball: { defaults: { ball_color: "#FF6A14" } },
      softball: { defaults: { ball_color: "#FACC15" } }
    }
  };
  var LOCAL_CONFIG_OVERRIDE = {};

  function mergeObjects(base, override) {
    var out = Array.isArray(base) ? base.slice() : Object.assign({}, base);
    if (!override || typeof override !== "object") return out;

    Object.keys(override).forEach(function (key) {
      var value = override[key];
      if (
        value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        out[key] &&
        typeof out[key] === "object" &&
        !Array.isArray(out[key])
      ) {
        out[key] = mergeObjects(out[key], value);
      } else {
        out[key] = value;
      }
    });

    return out;
  }

  function readInlineJsonConfig() {
    var el = document.getElementById("sp3d-preview-config-json");
    if (!el) return {};
    var raw = String(el.textContent || el.innerText || "").trim();
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      console.warn("[Sportify3D Preview] inline config JSON is invalid", error);
      return {};
    }
  }

  function loadRemoteJsonConfig(url) {
    var target = String(url || "").trim();
    if (!target) return Promise.resolve({});

    var headers = {};
    if (target.indexOf(".ngrok-") !== -1) {
      headers["ngrok-skip-browser-warning"] = "true";
    }

    return fetch(target, { headers: headers })
      .then(function (response) {
        if (!response.ok) throw new Error("Config request failed");
        return response.json();
      })
      .then(function (parsed) {
        return parsed && typeof parsed === "object" ? parsed : {};
      })
      .catch(function (error) {
        console.warn("[Sportify3D Preview] remote config load failed", error);
        return {};
      });
  }

  function resolveBootstrapConfig() {
    var config = mergeObjects({}, DEFAULT_CONFIG);
    if (LOCAL_CONFIG_OVERRIDE && typeof LOCAL_CONFIG_OVERRIDE === "object") {
      config = mergeObjects(config, LOCAL_CONFIG_OVERRIDE);
    }
    if (window.SP3D_PREVIEW_CONFIG && typeof window.SP3D_PREVIEW_CONFIG === "object") {
      config = mergeObjects(config, window.SP3D_PREVIEW_CONFIG);
    }

    var inlineConfig = readInlineJsonConfig();
    config = mergeObjects(config, inlineConfig);

    var remoteUrl = String(window.SP3D_PREVIEW_CONFIG_URL || config.configUrl || "").trim();
    if (!remoteUrl) return Promise.resolve(config);

    return loadRemoteJsonConfig(remoteUrl).then(function (remoteConfig) {
      return mergeObjects(config, remoteConfig);
    });
  }

  function normalizeLookupMap(value) {
    var out = {};
    if (!value || typeof value !== "object") return out;
    Object.keys(value).forEach(function (key) {
      out[String(key).trim().toLowerCase()] = value[key];
    });
    return out;
  }

  function normalizeSportKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function toArray(value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
  }

  function normalizeHex(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    if (raw[0] !== "#") raw = "#" + raw;

    var full = raw.match(/^#([0-9a-fA-F]{6})$/);
    if (full) return "#" + full[1].toUpperCase();

    var shortHex = raw.match(/^#([0-9a-fA-F]{3})$/);
    if (!shortHex) return "";
    var h = shortHex[1].toUpperCase();
    return "#" + h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }

  function normalizeColor(rawValue, key, config) {
    var value = String(rawValue || "").trim().toLowerCase();
    var mapped = config.colorAliases[value] || value;
    var hex = normalizeHex(mapped);
    if (!hex) return config.defaults[key];
    var enforceColorAllowlist = !!(config && config.enforceFrontendColorAllowlist);
    if (enforceColorAllowlist && config.allowedColors && config.allowedColors.length && config.allowedColors.indexOf(hex) === -1) {
      return config.defaults[key];
    }
    return hex;
  }

  function normalizeColorOrEmpty(rawValue, key, config) {
    var value = String(rawValue || "").trim().toLowerCase();
    if (!value) return "";
    var mapped = config.colorAliases[value] || value;
    var hex = normalizeHex(mapped);
    if (!hex) return "";
    var enforceColorAllowlist = !!(config && config.enforceFrontendColorAllowlist);
    if (enforceColorAllowlist && config.allowedColors && config.allowedColors.length && config.allowedColors.indexOf(hex) === -1) {
      return "";
    }
    return hex;
  }

  function normalizeFont(rawValue, config) {
    var value = String(rawValue || "").trim().toLowerCase();
    if (!value) return config.defaults.font;
    var mapped = config.fontAliases[value] || value;
    if (config.allowedFonts.indexOf(mapped) === -1) return config.defaults.font;
    return mapped;
  }

  function normalizeSport(rawValue, config) {
    var fallback = String(config.sport || config.defaults.sport || "baseball").trim().toLowerCase();
    var value = normalizeSportKey(rawValue);
    if (!value) return fallback;

    var mapped = config.sportAliases[value] || value;
    var strictAllowlist = !!(config && config.strictSportAllowlist);
    if (strictAllowlist && Array.isArray(config.allowedSports) && config.allowedSports.length && config.allowedSports.indexOf(mapped) === -1) {
      return fallback;
    }
    return mapped;
  }

  function isRecognizedSportValue(rawValue, config) {
    var value = normalizeSportKey(rawValue);
    if (!value) return false;
    var mapped = (config.sportAliases && config.sportAliases[value]) || value;
    var strictAllowlist = !!(config && config.strictSportAllowlist);
    if (!strictAllowlist) return !!mapped;
    if (!Array.isArray(config.allowedSports) || !config.allowedSports.length) return !!mapped;
    return config.allowedSports.indexOf(mapped) !== -1;
  }

  function mergeFieldMap(base, override) {
    var out = {};
    if (base && typeof base === "object" && !Array.isArray(base)) {
      out = mergeObjects(out, base);
    }
    if (override && typeof override === "object" && !Array.isArray(override)) {
      out = mergeObjects(out, override);
    }
    return out;
  }

  function resolveSportsMap(config) {
    return normalizeLookupMap((config && config.sports && typeof config.sports === "object") ? config.sports : {});
  }

  function firstSportConfig(config) {
    var sportsMap = resolveSportsMap(config);
    var keys = Object.keys(sportsMap);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      if (!key || key === "default" || key === "__default__" || key === "*") continue;
      var cfg = sportsMap[key];
      if (cfg && typeof cfg === "object" && !Array.isArray(cfg)) return cfg;
    }
    return {};
  }

  function resolveSportConfig(config, sportKey) {
    var sportsMap = resolveSportsMap(config);
    var mappedSport = normalizeSport(String(sportKey || ""), config);
    var defaultSport = normalizeSport(String((config && (config.sport || (config.defaults && config.defaults.sport))) || ""), config);
    var defaultBucket = sportsMap.default || sportsMap.__default__ || sportsMap["*"] || {};
    var defaultSportCfg = sportsMap[defaultSport] || {};
    var selectedSportCfg = sportsMap[mappedSport] || {};
    var fallbackSportCfg = firstSportConfig(config);
    var rootFields = (config && config.fields && typeof config.fields === "object" && !Array.isArray(config.fields))
      ? config.fields
      : {};

    var mergedDefaults = {};
    mergedDefaults = mergeObjects(mergedDefaults, defaultBucket.defaults || {});
    mergedDefaults = mergeObjects(mergedDefaults, defaultSportCfg.defaults || {});
    mergedDefaults = mergeObjects(mergedDefaults, fallbackSportCfg.defaults || {});
    mergedDefaults = mergeObjects(mergedDefaults, selectedSportCfg.defaults || {});

    var mergedFields = {};
    mergedFields = mergeFieldMap(mergedFields, defaultBucket.fields || {});
    mergedFields = mergeFieldMap(mergedFields, defaultSportCfg.fields || {});
    mergedFields = mergeFieldMap(mergedFields, fallbackSportCfg.fields || {});
    mergedFields = mergeFieldMap(mergedFields, selectedSportCfg.fields || {});
    mergedFields = mergeFieldMap(mergedFields, rootFields);

    return {
      sport: mappedSport,
      defaults: mergedDefaults,
      fields: mergedFields
    };
  }

  function deriveAllowedSports(config) {
    var out = [];
    var seen = {};
    function add(raw) {
      var key = normalizeSportKey(raw);
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    }

    toArray(config && config.allowedSports).forEach(add);
    add(config && config.sport);
    add(config && config.defaults && config.defaults.sport);

    var sportsMap = resolveSportsMap(config);
    Object.keys(sportsMap).forEach(function (key) {
      if (key === "default" || key === "__default__" || key === "*") return;
      add(key);
    });

    var aliases = normalizeLookupMap(config && config.sportAliases);
    Object.keys(aliases).forEach(function (aliasKey) {
      add(aliasKey);
      add(aliases[aliasKey]);
    });

    var presets = normalizeLookupMap((config && config.presets && typeof config.presets === "object") ? config.presets : {});
    Object.keys(presets).forEach(function (presetKey) {
      var preset = presets[presetKey];
      if (preset && typeof preset === "object" && !Array.isArray(preset) && preset.sport) {
        add(preset.sport);
      }
    });

    return out;
  }

  function normalizeDesign(rawValue, fallbackValue) {
    var fallback = String(fallbackValue || "tag").trim().toLowerCase();
    var value = String(rawValue || "").trim().toLowerCase();
    if (!value) return fallback || "tag";
    // Translated option values (French storefront) map back to the model names
    var designAliases = { ronde: "round", rond: "round", classique: "classic", "écusson": "classic", ecusson: "classic" };
    if (designAliases[value]) return designAliases[value];
    var cleaned = value.replace(/[^a-z0-9_-]/g, "");
    return cleaned || fallback || "tag";
  }

  function cleanText(value, maxLen) {
    return String(value || "").trim().toUpperCase().slice(0, maxLen);
  }

  function protectTagNameSpacing(value) {
    return String(value || "").replace(/ +/g, "\u00A0");
  }

  function normalizeTeamLookupKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function teamUniqueStrings(values) {
    var out = [];
    var seen = {};
    toArray(values).forEach(function (value) {
      var v = String(value || "").trim();
      if (!v) return;
      var key = normalizeTeamLookupKey(v);
      if (seen[key]) return;
      seen[key] = true;
      out.push(v);
    });
    return out;
  }

  function teamEscapeAttrValue(value) {
    return String(value || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function normalizeTeamOptionBase(value) {
    return normalizeTeamLookupKey(value).replace(/[:_\-\s]+$/g, "");
  }

  function resolveTeamFieldNameRegex(teamCfg) {
    var raw = String((teamCfg && teamCfg.fieldNameRegex) || "^name[:_\\- ]?\\d+$").trim();
    try {
      return new RegExp(raw, "i");
    } catch (_err) {
      return /^name[:_\- ]?\d+$/i;
    }
  }

  function getPropertyOptionName(field) {
    if (!field || !field.getAttribute) return "";
    var raw = String(field.getAttribute("name") || "").trim();
    var match = raw.match(/^properties\[(.+)\]$/);
    if (match && match[1]) return String(match[1]).trim();
    // Support snippet-native raw names like "name_1", "name_2", etc.
    if (/^name[:_\- ]?\d+$/i.test(raw) || /^name$/i.test(raw)) return raw;
    return "";
  }

  function teamOptionMatches(fieldOptionName, optionName) {
    var fieldKey = normalizeTeamLookupKey(fieldOptionName);
    var base = normalizeTeamOptionBase(optionName);
    if (!fieldKey || !base) return false;
    if (fieldKey === base) return true;
    if (fieldKey.indexOf(base + "_") === 0) return true;
    if (fieldKey.indexOf(base + "-") === 0) return true;
    if (fieldKey.indexOf(base + " ") === 0) return true;
    if (fieldKey.indexOf(base + ":") === 0) return true;
    return false;
  }

  function getTeamPropertyFieldsPool(form) {
    var out = [];
    var seen = [];

    function pushNodes(nodeList) {
      if (!nodeList || !nodeList.length) return;
      for (var i = 0; i < nodeList.length; i += 1) {
        var node = nodeList[i];
        if (seen.indexOf(node) !== -1) continue;
        seen.push(node);
        out.push(node);
      }
    }

    if (form) {
      pushNodes(form.querySelectorAll(
        "input[name^='properties['], textarea[name^='properties['], input[name^='name_'], input[name^='Name_'], textarea[name^='name_'], textarea[name^='Name_']"
      ));
      if (form.id) {
        var formId = teamEscapeAttrValue(form.id);
        pushNodes(document.querySelectorAll(
          "input[name^='properties['][form=\"" + formId + "\"], textarea[name^='properties['][form=\"" + formId + "\"], input[name^='name_'][form=\"" + formId + "\"], input[name^='Name_'][form=\"" + formId + "\"], textarea[name^='name_'][form=\"" + formId + "\"], textarea[name^='Name_'][form=\"" + formId + "\"]"
        ));
      }
    }

    if (!out.length) {
      pushNodes(document.querySelectorAll(
        "input[name^='properties['], textarea[name^='properties['], input[name^='name_'], input[name^='Name_'], textarea[name^='name_'], textarea[name^='Name_']"
      ));
    }

    return out;
  }

  function getAllPropertyFieldsPool(form) {
    var out = [];
    var seen = [];

    function pushNodes(nodeList) {
      if (!nodeList || !nodeList.length) return;
      for (var i = 0; i < nodeList.length; i += 1) {
        var node = nodeList[i];
        if (seen.indexOf(node) !== -1) continue;
        seen.push(node);
        out.push(node);
      }
    }

    if (form) {
      pushNodes(form.querySelectorAll(
        "input[name^='properties['], select[name^='properties['], textarea[name^='properties['], input[name^='name_'], input[name^='Name_'], textarea[name^='name_'], textarea[name^='Name_']"
      ));
      if (form.id) {
        var formId = teamEscapeAttrValue(form.id);
        pushNodes(document.querySelectorAll(
          "input[name^='properties['][form=\"" + formId + "\"], select[name^='properties['][form=\"" + formId + "\"], textarea[name^='properties['][form=\"" + formId + "\"], input[name^='name_'][form=\"" + formId + "\"], input[name^='Name_'][form=\"" + formId + "\"], textarea[name^='name_'][form=\"" + formId + "\"], textarea[name^='Name_'][form=\"" + formId + "\"]"
        ));
      }
    }

    if (!out.length) {
      pushNodes(document.querySelectorAll(
        "input[name^='properties['], select[name^='properties['], textarea[name^='properties['], input[name^='name_'], input[name^='Name_'], textarea[name^='name_'], textarea[name^='Name_']"
      ));
    }

    return out;
  }

  function normalizePropertyOptionKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_:-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function putIfMissing(map, key, value) {
    if (!key || map[key]) return;
    map[key] = value;
  }

  function buildPropertyValuesMap(form) {
    var fields = getAllPropertyFieldsPool(form);
    var out = {};
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (!field) continue;
      var optionName = getPropertyOptionName(field);
      if (!optionName) continue;
      var value = String(valueFromElement(field) || "").trim();
      if (!value) continue;

      var key = normalizePropertyOptionKey(optionName);
      if (!key) continue;

      putIfMissing(out, key, value);
      putIfMissing(out, key.replace(/\s+/g, ""), value);
      putIfMissing(out, key.replace(/\s+\d+$/g, "").trim(), value);
      putIfMissing(out, key.replace(/\s*[#]\s*\d+$/g, "").trim(), value);
    }
    return out;
  }

  function firstPropertyValueByAliases(propertyValuesMap, aliases) {
    if (!propertyValuesMap || typeof propertyValuesMap !== "object") return "";
    var list = toArray(aliases);
    for (var i = 0; i < list.length; i += 1) {
      var raw = String(list[i] || "").trim();
      if (!raw) continue;
      var normalized = normalizePropertyOptionKey(raw);
      if (normalized && propertyValuesMap[normalized]) return propertyValuesMap[normalized];
      var compact = normalized.replace(/\s+/g, "");
      if (compact && propertyValuesMap[compact]) return propertyValuesMap[compact];
    }
    return "";
  }

  function applyPropertyFallbacks(resolved, config) {
    var out = resolved && typeof resolved === "object" ? resolved : {};
    var propertyValues = buildPropertyValuesMap(findPrimaryProductForm());
    if (!propertyValues || !Object.keys(propertyValues).length) return out;

    function assignIfMissing(key, aliases) {
      if (out[key] !== undefined && String(out[key]).trim() !== "") return;
      var value = firstPropertyValueByAliases(propertyValues, aliases);
      if (value !== "") out[key] = value;
    }

    assignIfMissing("design", ["design", "model", "modele", "modèle"]);
    assignIfMissing("sport_option", ["sport"]);
    assignIfMissing("name", ["name", "name:", "name 1", "name #1", "player name", "nom"]);
    assignIfMissing("name_1", ["name 1", "name #1", "name_1", "name:_1"]);
    assignIfMissing("text_02", ["second row text", "text 02", "text_02", "top text", "number on stick", "text stick"]);
    assignIfMissing("text_02_1", ["second row text 1", "text 02 1", "text_02_1", "top text 1"]);
    assignIfMissing("text_03", ["third row text", "text 03", "text_03"]);
    assignIfMissing("text_03_1", ["third row text 1", "text 03 1", "text_03_1"]);
    assignIfMissing("text_04", ["fourth row text", "text 04", "text_04"]);
    assignIfMissing("text_04_1", ["fourth row text 1", "text 04 1", "text_04_1"]);
    assignIfMissing("back_text", ["back text", "back_text", "other", "autre"]);
    assignIfMissing("back_text_1", ["back text 1", "back_text_1", "other 1", "autre 1"]);
    assignIfMissing("font", ["font", "police"]);
    assignIfMissing("classic_colors", ["classic colors", "couleurs classiques"]);
    assignIfMissing("text_main_color", ["color1", "main text color", "main color", "couleur texte principal"]);
    assignIfMissing("outline1_color", ["outline1", "outline 1", "outline#1", "top text outline"]);
    assignIfMissing("outline2_color", ["outline2", "outline 2", "outline#2", "bottom text outline"]);
    assignIfMissing("text_02_main_color", ["second row color", "text 02 color", "top text color"]);
    assignIfMissing("text_02_outline1_color", ["second row outline1", "second row outline 1", "text 02 outline1"]);
    assignIfMissing("text_02_outline2_color", ["second row outline2", "second row outline 2", "text 02 outline2"]);
    assignIfMissing("back_text_color", ["back text color"]);
    assignIfMissing("back_ball_color", ["back ball", "back ball color"]);
    assignIfMissing("ball_color", ["ball", "ball color"]);
    assignIfMissing("stitches_color", ["stitches", "stitches color"]);
    return out;
  }

  function isVisibleTeamField(el, teamCfg, teamFieldRegex) {
    if (!el || el.disabled) return false;
    var type = String(el.type || "").toLowerCase();
    if (type === "hidden") {
      // Allow hidden snippet-provided team fields (e.g. properties[name_1]) while
      // still ignoring unrelated hidden inputs.
      var optionName = getPropertyOptionName(el);
      var regex = teamFieldRegex || resolveTeamFieldNameRegex(teamCfg || {});
      if (optionName && regex.test(normalizeTeamLookupKey(optionName))) return true;
      if (el.hasAttribute("data-nlb-prop") || el.hasAttribute("data-mlb-live") || el.hasAttribute("data-mlb-prop")) return true;
      return false;
    }
    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (style && (style.display === "none" || style.visibility === "hidden")) return false;
    if (el.offsetParent === null && (!el.getClientRects || !el.getClientRects().length)) return false;
    return true;
  }

  function readTeamPreviewOptionNamesFromLpoConfig(config) {
    var teamCfg = (config && config.teamPreview) || {};
    if (teamCfg.enabled === false) return [];

    var targetGroupNames = teamUniqueStrings(teamCfg.groupNames).map(normalizeTeamLookupKey);
    if (!targetGroupNames.length) return [];

    var matchMode = String(teamCfg.groupMatchMode || "exact").toLowerCase();
    var preferFirst = teamCfg.preferFirstMatchingGroup !== false;
    var cloudliftConfig = window.Cloudlift && window.Cloudlift.options && window.Cloudlift.options.config;
    var configs = cloudliftConfig && Array.isArray(cloudliftConfig.configs) ? cloudliftConfig.configs : [];
    if (!configs.length) return [];

    var selectedFirst = null;
    var collected = [];

    function walkOptions(options) {
      if (!Array.isArray(options)) return;
      if (preferFirst && selectedFirst && selectedFirst.length) return;
      for (var i = 0; i < options.length; i += 1) {
        var opt = options[i];
        if (!opt || typeof opt !== "object") continue;

        var children = Array.isArray(opt.options) ? opt.options : [];
        var optionGroupName = normalizeTeamLookupKey(opt.name);
        var isTargetGroup = false;
        for (var g = 0; g < targetGroupNames.length; g += 1) {
          var wanted = targetGroupNames[g];
          if (!wanted) continue;
          if (matchMode === "partial") {
            if (optionGroupName === wanted || optionGroupName.indexOf(wanted) !== -1 || wanted.indexOf(optionGroupName) !== -1) {
              isTargetGroup = true;
              break;
            }
          } else if (optionGroupName === wanted) {
            isTargetGroup = true;
            break;
          }
        }
        isTargetGroup = children.length && isTargetGroup;

        if (isTargetGroup) {
          var directTextChildren = [];
          for (var j = 0; j < children.length; j += 1) {
            var child = children[j];
            if (!child || typeof child !== "object") continue;
            var optionName = String(child.name || "").trim();
            var optionType = String(child.type || "").trim().toLowerCase();
            if (!optionName) continue;
            if (optionType === "text" || optionType === "textarea") {
              directTextChildren.push(optionName);
            }
          }
          if (preferFirst && directTextChildren.length) {
            selectedFirst = teamUniqueStrings(directTextChildren);
            return;
          }
          collected = collected.concat(directTextChildren);
        }

        if (children.length) walkOptions(children);
        if (preferFirst && selectedFirst && selectedFirst.length) return;
      }
    }

    for (var c = 0; c < configs.length; c += 1) {
      walkOptions(configs[c] && configs[c].options);
    }

    if (preferFirst && selectedFirst && selectedFirst.length) return selectedFirst;
    return teamUniqueStrings(collected);
  }

  function collectTeamPreviewNames(config, optionNames, form) {
    var teamCfg = (config && config.teamPreview) || {};
    if (teamCfg.enabled === false) return [];
    var fieldNameRegex = resolveTeamFieldNameRegex(teamCfg);

    var maxNames = parseInt(String(teamCfg.maxNames || 50), 10);
    if (!isFinite(maxNames) || maxNames < 1) maxNames = 50;
    var nameLimit = parseInt(String((config && config.limits && config.limits.name) || 16), 10);
    if (!isFinite(nameLimit) || nameLimit < 1) nameLimit = 16;

    var pool = getTeamPropertyFieldsPool(form);
    var tracked = [];
    var seenByRawName = {};
    var namesLookup = teamUniqueStrings(optionNames);

    for (var i = pool.length - 1; i >= 0; i -= 1) {
      var field = pool[i];
      if (!isVisibleTeamField(field, teamCfg, fieldNameRegex)) continue;

      var optionKey = getPropertyOptionName(field);
      if (!optionKey) continue;

      var isTracked = false;
      if (namesLookup.length) {
        for (var j = 0; j < namesLookup.length; j += 1) {
          if (teamOptionMatches(optionKey, namesLookup[j])) {
            isTracked = true;
            break;
          }
        }
      } else if (fieldNameRegex.test(normalizeTeamLookupKey(optionKey))) {
        isTracked = true;
      } else if (teamCfg.fallbackMatchNameFields !== false) {
        var normalized = normalizeTeamLookupKey(optionKey);
        isTracked = normalized.indexOf("name") !== -1 && /\d/.test(normalized);
      }

      if (!isTracked) continue;
      var slotKey = normalizeTeamLookupKey(optionKey).replace(/[:_\-\s]+(\d+)$/i, "#$1");
      if (!slotKey || seenByRawName[slotKey]) continue;
      seenByRawName[slotKey] = true;

      var chunks = String(valueFromElement(field) || "").split(/[\n,;|]+/);
      for (var v = 0; v < chunks.length; v += 1) {
        var value = cleanText(chunks[v], nameLimit);
        if (!value) continue;
        tracked.unshift(value);
        if (tracked.length >= maxNames) break;
      }
      if (tracked.length >= maxNames) break;
    }

    return tracked;
  }

  function collectStructuredTeamPreviewEntries(config, form) {
    var fields = [];
    var seen = [];

    function pushNodes(nodeList) {
      if (!nodeList || !nodeList.length) return;
      for (var idx = 0; idx < nodeList.length; idx += 1) {
        var node = nodeList[idx];
        if (!node || seen.indexOf(node) !== -1) continue;
        seen.push(node);
        fields.push(node);
      }
    }

    if (form && form.querySelectorAll) {
      pushNodes(form.querySelectorAll("input[data-nlb-live], input[data-nlb-prop], textarea[data-nlb-live], textarea[data-nlb-prop]"));
    }
    if (!fields.length && document && document.querySelectorAll) {
      pushNodes(document.querySelectorAll("input[data-nlb-live], input[data-nlb-prop], textarea[data-nlb-live], textarea[data-nlb-prop]"));
    }
    if (!fields.length) {
      fields = getAllPropertyFieldsPool(form);
    }

    var rows = {};
    var indices = [];
    var nameLimit = parseInt(String((config && config.limits && config.limits.name) || 16), 10);
    var textLimit = parseInt(String((config && config.limits && config.limits.text_02) || (config && config.limits && config.limits.back_text) || 16), 10);
    if (!isFinite(nameLimit) || nameLimit < 1) nameLimit = 16;
    if (!isFinite(textLimit) || textLimit < 1) textLimit = 16;

    function ensureRow(index) {
      if (!rows[index]) {
        rows[index] = { index: index, name: "", text_02: "" };
        indices.push(index);
      }
      return rows[index];
    }

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (!field) continue;
      var optionName = getPropertyOptionName(field);
      if (!optionName) continue;
      var value = String(valueFromElement(field) || "").trim();
      if (!value) continue;

      var normalized = normalizePropertyOptionKey(optionName);
      var nameMatch = normalized.match(/^name\s+(\d+)$/);
      if (nameMatch) {
        ensureRow(parseInt(nameMatch[1], 10)).name = cleanText(value, nameLimit);
        continue;
      }

      var text02Match = normalized.match(/^text\s+02\s+(\d+)$/);
      if (text02Match) {
        ensureRow(parseInt(text02Match[1], 10)).text_02 = cleanText(value, textLimit);
      }
    }

    indices.sort(function(a, b) { return a - b; });
    return indices.map(function(index) {
      return rows[index];
    }).filter(function(row) {
      return !!row.name;
    });
  }

  function parseProductHandleFromUrl(urlValue) {
    var match = String(urlValue || "").match(/\/products\/([^/?#]+)/i);
    if (!match || !match[1]) return "";
    return decodeURIComponent(match[1]).trim().toLowerCase();
  }

  function detectProductHandle() {
    if (window.meta && window.meta.product && window.meta.product.handle) {
      return String(window.meta.product.handle).trim().toLowerCase();
    }
    var og = document.querySelector("meta[property='og:url']");
    if (og && og.content) return parseProductHandleFromUrl(og.content);
    return parseProductHandleFromUrl(window.location && window.location.pathname);
  }

  function detectProductType() {
    if (window.meta && window.meta.product && window.meta.product.type) {
      return String(window.meta.product.type).trim().toLowerCase();
    }
    return "";
  }

  function readMetaPresetFromObject(metaObj) {
    if (!metaObj || typeof metaObj !== "object") return "";

    var directKeys = [
      "sp3d_preset",
      "sp3dPreset",
      "preview_preset",
      "previewPreset",
      "preset"
    ];
    for (var i = 0; i < directKeys.length; i += 1) {
      var directValue = metaObj[directKeys[i]];
      if (typeof directValue === "string" && directValue.trim()) {
        return String(directValue).trim();
      }
    }

    var metafields = metaObj.metafields;
    if (!metafields || typeof metafields !== "object") return "";

    var namespaces = ["sp3d", "custom"];
    var fieldKeys = ["preview_preset", "sp3d_preview_preset", "preset"];
    for (var n = 0; n < namespaces.length; n += 1) {
      var ns = namespaces[n];
      var nsObj = metafields[ns];
      if (!nsObj || typeof nsObj !== "object") continue;
      for (var f = 0; f < fieldKeys.length; f += 1) {
        var fieldValue = nsObj[fieldKeys[f]];
        if (typeof fieldValue === "string" && fieldValue.trim()) {
          return String(fieldValue).trim();
        }
        if (fieldValue && typeof fieldValue === "object" && typeof fieldValue.value === "string" && fieldValue.value.trim()) {
          return String(fieldValue.value).trim();
        }
      }
    }

    return "";
  }

  function detectProductPreset() {
    var globals = [
      window.SP3D_PREVIEW_PRODUCT_PRESET,
      window.SP3D_PRODUCT_PRESET,
      window.SP3D_PREVIEW_PRESET
    ];
    for (var i = 0; i < globals.length; i += 1) {
      var v = globals[i];
      if (typeof v === "string" && v.trim()) return String(v).trim().toLowerCase();
    }

    var metaFromWindow = readMetaPresetFromObject(window.meta && window.meta.product);
    if (metaFromWindow) return String(metaFromWindow).trim().toLowerCase();

    var metaTag = document.querySelector("meta[name='sp3d:preset'], meta[property='sp3d:preset']");
    if (metaTag) {
      var metaTagValue = String(metaTag.getAttribute("content") || "").trim();
      if (metaTagValue) return metaTagValue.toLowerCase();
    }

    var htmlPreset = String(document.documentElement.getAttribute("data-sp3d-preset") || "").trim();
    if (htmlPreset) return htmlPreset.toLowerCase();

    return "";
  }

  var PRODUCT_META_CACHE = null;

  function looksLikeProductMeta(obj) {
    return !!(
      obj &&
      typeof obj === "object" &&
      Array.isArray(obj.variants)
    );
  }

  function inferSportFromVariantRecord(variant, config) {
    if (!variant || typeof variant !== "object") return "";

    var candidates = [
      variant.option1,
      variant.option2,
      variant.option3,
      variant.public_title,
      variant.title
    ];

    var fullName = String(variant.name || "").trim();
    if (fullName) {
      candidates.push(fullName);
      var split = fullName.split(" - ");
      if (split.length > 1) {
        candidates.push(split[split.length - 1]);
      }
    }

    for (var i = 0; i < candidates.length; i += 1) {
      var value = String(candidates[i] || "").trim();
      if (!value) continue;
      if (isRecognizedSportValue(value, config)) return value;
    }
    return "";
  }

  function resolveProductMeta() {
    if (window.meta && window.meta.product && looksLikeProductMeta(window.meta.product)) {
      return window.meta.product;
    }
    if (PRODUCT_META_CACHE) return PRODUCT_META_CACHE;

    var scripts = document.querySelectorAll("script[type='application/json']");
    for (var i = 0; i < scripts.length; i += 1) {
      var raw = String(scripts[i].textContent || scripts[i].innerText || "").trim();
      if (!raw) continue;
      if (raw.indexOf("variants") === -1 || raw.indexOf("options") === -1) continue;
      try {
        var parsed = JSON.parse(raw);
        if (looksLikeProductMeta(parsed)) {
          PRODUCT_META_CACHE = parsed;
          return parsed;
        }
        if (parsed && typeof parsed === "object") {
          if (looksLikeProductMeta(parsed.product)) {
            PRODUCT_META_CACHE = parsed.product;
            return parsed.product;
          }
          if (looksLikeProductMeta(parsed.data)) {
            PRODUCT_META_CACHE = parsed.data;
            return parsed.data;
          }
        }
      } catch (_err) {}
    }
    return null;
  }

  function normalizeOptionName(value) {
    return String(value || "").trim().toLowerCase();
  }

  function parseVariantOptionNameFromFieldName(fieldName) {
    var raw = String(fieldName || "").replace(/\s+/g, " ").trim();
    var match = raw.match(/^options\[(.+)\]$/i);
    if (match && match[1]) return String(match[1]).trim();
    // Dawn-like variant radio names: "Sport-1"
    var fallbackMatch = raw.match(/^(.+?)-\d+$/);
    if (!fallbackMatch || !fallbackMatch[1]) return "";
    return String(fallbackMatch[1]).trim();
  }

  function parseVariantOptionNameFromElement(el) {
    if (!el) return "";
    var nameAttr = String(el.getAttribute && el.getAttribute("name") || "").trim();
    var fromName = parseVariantOptionNameFromFieldName(nameAttr);
    if (fromName) return fromName;

    var dataOptionName = String(el.getAttribute && el.getAttribute("data-option-name") || "").trim();
    if (dataOptionName) return dataOptionName;

    if (el.closest) {
      var fieldset = el.closest("fieldset");
      if (fieldset) {
        var legend = fieldset.querySelector("legend");
        var legendText = String(legend && (legend.textContent || legend.innerText) || "").trim();
        if (legendText) return legendText;
      }
    }
    return "";
  }

  function findPrimaryProductForm() {
    var candidates = [];
    var seen = [];

    function push(form) {
      if (!form || seen.indexOf(form) !== -1) return;
      seen.push(form);
      candidates.push(form);
    }

    var viewer = document.querySelector("#sp3d-viewer");
    if (viewer && viewer.closest) push(viewer.closest("form"));

    var card = document.querySelector("#sp3d-preview-card");
    if (card && card.closest) {
      push(card.closest("form[data-type='add-to-cart-form']"));
      push(card.closest("form[action*='/cart/add']"));
      push(card.closest("form"));
    }

    var addProxy = document.querySelector("#sp3d-add-to-cart-btn");
    if (addProxy && addProxy.closest) {
      push(addProxy.closest("form[data-type='add-to-cart-form']"));
      push(addProxy.closest("form[action*='/cart/add']"));
      push(addProxy.closest("form"));
    }

    push(document.querySelector("form[data-type='add-to-cart-form']"));
    push(document.querySelector("form[action*='/cart/add']:not(.installment)"));
    push(document.querySelector("form[action*='/cart/add']"));

    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i]) return candidates[i];
    }
    return null;
  }

  function queryVariantFields(selector) {
    var out = [];
    var seen = [];

    function pushNodes(nodeList) {
      if (!nodeList || !nodeList.length) return;
      for (var i = 0; i < nodeList.length; i += 1) {
        var node = nodeList[i];
        if (!node || seen.indexOf(node) !== -1) continue;
        seen.push(node);
        out.push(node);
      }
    }

    var form = findPrimaryProductForm();
    if (form) {
      try {
        pushNodes(form.querySelectorAll(selector));
      } catch (_err) {}

      var formId = String(form.getAttribute("id") || "").trim();
      if (formId) {
        try {
          pushNodes(document.querySelectorAll(selector + "[form=\"" + teamEscapeAttrValue(formId) + "\"]"));
        } catch (_err2) {}
      }
    }

    if (!out.length) {
      try {
        pushNodes(document.querySelectorAll(selector));
      } catch (_err3) {}
    }

    return out;
  }

  function collectSelectedVariantOptionEntries(config) {
    var out = [];
    var seen = [];
    var selectors = toArray(config && config.variantFieldSelectors).filter(Boolean);
    if (!selectors.length) {
      selectors = ["input[name^='options[']:checked", "select[name^='options[']"];
    }

    function pushEntry(el) {
      if (!el || seen.indexOf(el) !== -1) return;
      seen.push(el);
      var optionName = parseVariantOptionNameFromElement(el);
      if (!optionName) return;
      var value = valueFromElement(el);
      if (!value) return;
      out.push({
        optionName: optionName,
        value: value
      });
    }

    for (var i = 0; i < selectors.length; i += 1) {
      var selector = String(selectors[i] || "").trim();
      if (!selector) continue;
      var nodes = queryVariantFields(selector);
      for (var n = 0; n < nodes.length; n += 1) {
        pushEntry(nodes[n]);
      }
    }

    return out;
  }

  function detectSelectedVariantId() {
    var form = findPrimaryProductForm();
    var variantInput = null;
    if (form) {
      variantInput = form.querySelector("input[name='id']");
      if (!variantInput && form.id) {
        var formId = teamEscapeAttrValue(form.id);
        variantInput = document.querySelector("input[name='id'][form=\"" + formId + "\"]");
      }
    }
    if (!variantInput) {
      variantInput = document.querySelector("form[action*='/cart/add'] input[name='id'], input[name='id'][form]");
    }
    if (variantInput && String(variantInput.value || "").trim()) {
      return String(variantInput.value).trim();
    }

    if (window.meta && window.meta.product && window.meta.product.selected_variant_id) {
      return String(window.meta.product.selected_variant_id).trim();
    }

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.selectedVariantId
    ) {
      return String(window.ShopifyAnalytics.meta.selectedVariantId).trim();
    }

    // Keep URL variant as last fallback because it can be stale after dynamic variant switches.
    if (window.location && window.location.search) {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = String(params.get("variant") || "").trim();
        if (fromUrl) return fromUrl;
      } catch (_err) {}
    }

    return "";
  }

  function resolveVariantFromSelectedOptions(metaProduct, config) {
    if (!metaProduct || !Array.isArray(metaProduct.variants)) return null;
    var entries = collectSelectedVariantOptionEntries(config);
    if (!entries.length) return null;

    var optionsList = Array.isArray(metaProduct.options) ? metaProduct.options : [];
    var optionToIndex = {};
    for (var oi = 0; oi < optionsList.length && oi < 3; oi += 1) {
      var optionName = "";
      var optionRaw = optionsList[oi];
      if (typeof optionRaw === "string") optionName = optionRaw;
      else if (optionRaw && typeof optionRaw === "object") optionName = optionRaw.name || "";
      var optionKey = normalizeOptionName(optionName);
      if (optionKey) optionToIndex[optionKey] = oi + 1;
    }

    var selectedByOptionName = {};
    for (var i = 0; i < entries.length; i += 1) {
      var entry = entries[i];
      if (!entry || !entry.optionName) continue;
      var key = normalizeOptionName(entry.optionName);
      var val = String(entry.value || "").trim();
      if (!key || !val) continue;
      selectedByOptionName[key] = val;
    }
    var selectedKeys = Object.keys(selectedByOptionName);
    if (!selectedKeys.length) return null;

    for (var v = 0; v < metaProduct.variants.length; v += 1) {
      var variant = metaProduct.variants[v];
      if (!variant) continue;
      var allMatch = true;
      for (var k = 0; k < selectedKeys.length; k += 1) {
        var selectedKey = selectedKeys[k];
        var idx = optionToIndex[selectedKey];
        var selectedValue = String(selectedByOptionName[selectedKey] || "").trim().toLowerCase();
        if (idx) {
          var variantValue = String(variant["option" + String(idx)] || "").trim().toLowerCase();
          if (!variantValue || variantValue !== selectedValue) {
            allMatch = false;
            break;
          }
          continue;
        }

        // No option index metadata available: compare against common variant labels.
        var fallbackMatched = false;
        var fallbackCandidates = [
          variant.option1,
          variant.option2,
          variant.option3,
          variant.public_title,
          variant.title
        ];
        var variantName = String(variant.name || "").trim();
        if (variantName) {
          fallbackCandidates.push(variantName);
          var splitName = variantName.split(" - ");
          if (splitName.length > 1) {
            fallbackCandidates.push(splitName[splitName.length - 1]);
          }
        }
        for (var c = 0; c < fallbackCandidates.length; c += 1) {
          var candidate = String(fallbackCandidates[c] || "").trim().toLowerCase();
          if (!candidate) continue;
          if (candidate === selectedValue) {
            fallbackMatched = true;
            break;
          }
        }
        if (!fallbackMatched) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) return variant;
    }

    return null;
  }

  function resolveVariantOptionValue(optionName, config) {
    var metaProduct = resolveProductMeta();
    if (!metaProduct || !Array.isArray(metaProduct.variants)) return "";

    var requestedOption = normalizeOptionName(optionName || "sport");
    var optionsList = Array.isArray(metaProduct.options) ? metaProduct.options : [];
    var optionIndex = -1;
    for (var i = 0; i < optionsList.length; i += 1) {
      var opt = optionsList[i];
      var optName = "";
      if (typeof opt === "string") optName = opt;
      else if (opt && typeof opt === "object") optName = opt.name || "";
      if (normalizeOptionName(optName) === requestedOption) {
        optionIndex = i;
        break;
      }
    }
    if (optionIndex < 0) {
      for (var j = 0; j < optionsList.length; j += 1) {
        var fallbackOpt = optionsList[j];
        var fallbackName = "";
        if (typeof fallbackOpt === "string") fallbackName = fallbackOpt;
        else if (fallbackOpt && typeof fallbackOpt === "object") fallbackName = fallbackOpt.name || "";
        if (normalizeOptionName(fallbackName).indexOf("sport") !== -1) {
          optionIndex = j;
          break;
        }
      }
    }
    var variantFromSelectedOptions = resolveVariantFromSelectedOptions(metaProduct, config);
    if (optionIndex < 0 || optionIndex > 2) {
      // If option name matching failed, still try to infer sport from selected variant values.
      var selectedVariantIdFallback = detectSelectedVariantId();
      var selectedVariantFallback = variantFromSelectedOptions;
      if (!selectedVariantFallback && selectedVariantIdFallback) {
        for (var vf = 0; vf < metaProduct.variants.length; vf += 1) {
          var cand = metaProduct.variants[vf];
          if (!cand) continue;
          if (String(cand.id || "") === selectedVariantIdFallback) {
            selectedVariantFallback = cand;
            break;
          }
        }
      }
      if (!selectedVariantFallback && metaProduct.variants.length) {
        selectedVariantFallback = metaProduct.variants[0];
      }
      if (selectedVariantFallback) {
        var inferredFallback = inferSportFromVariantRecord(selectedVariantFallback, config);
        if (inferredFallback) return inferredFallback;
      }
      return "";
    }

    var selectedVariantId = detectSelectedVariantId();
    var variant = variantFromSelectedOptions;
    if (!variant && selectedVariantId) {
      for (var v = 0; v < metaProduct.variants.length; v += 1) {
        var candidate = metaProduct.variants[v];
        if (!candidate) continue;
        if (String(candidate.id || "") === selectedVariantId) {
          variant = candidate;
          break;
        }
      }
    }
    if (!variant && metaProduct.variants.length) {
      variant = metaProduct.variants[0];
    }
    if (!variant) return "";

    var key = "option" + String(optionIndex + 1);
    var variantValue = String(variant[key] || "").trim();
    if (variantValue) return variantValue;

    return inferSportFromVariantRecord(variant, config);
  }

  function resolveVariantSportValue(config, resolved) {
    var optionName = String((config && config.variantSportOptionName) || "Sport").trim();
    var requested = normalizeOptionName(optionName || "sport");
    var entries = collectSelectedVariantOptionEntries(config);
    for (var i = 0; i < entries.length; i += 1) {
      var entry = entries[i];
      if (!entry || !entry.optionName) continue;
      var current = normalizeOptionName(entry.optionName);
      if (current === requested) return String(entry.value || "").trim();
    }
    for (var j = 0; j < entries.length; j += 1) {
      var fallbackEntry = entries[j];
      if (!fallbackEntry || !fallbackEntry.optionName) continue;
      var fallbackName = normalizeOptionName(fallbackEntry.optionName);
      if (fallbackName.indexOf("sport") !== -1) return String(fallbackEntry.value || "").trim();
    }
    for (var k = 0; k < entries.length; k += 1) {
      var recognizedEntry = entries[k];
      if (!recognizedEntry) continue;
      if (isRecognizedSportValue(recognizedEntry.value, config)) {
        return String(recognizedEntry.value || "").trim();
      }
    }

    var explicit = String((resolved && (resolved.variant_sport || resolved.sport_option)) || "").trim();
    if (isRecognizedSportValue(explicit, config)) return explicit;

    var fromMeta = resolveVariantOptionValue(optionName || "Sport", config);
    if (fromMeta) return fromMeta;

    return "";
  }

  function resolveVariantDesignValue(config) {
    var entries = collectSelectedVariantOptionEntries(config);
    for (var i = 0; i < entries.length; i += 1) {
      var entry = entries[i];
      if (!entry || !entry.optionName) continue;
      var optionName = normalizeOptionName(entry.optionName);
      if (!optionName) continue;
      if (optionName.indexOf("design") !== -1 || optionName.indexOf("model") !== -1 || optionName.indexOf("modele") !== -1 || optionName.indexOf("modèle") !== -1 || optionName.indexOf("conception") !== -1 || optionName.indexOf("forme") !== -1) {
        var value = String(entry.value || "").trim();
        if (value) return value;
      }
    }
    return "";
  }

  function isVariantSelectorField(target) {
    if (!target || typeof target.matches !== "function") return false;
    try {
      if (target.matches("input[name^='options['], select[name^='options[']")) return true;
      if (target.matches("variant-selects input, variant-selects select")) return true;
      if (target.matches(".product-form__input input[type='radio'], .product-form__input select")) return true;
      if (target.matches("input[name='id'][form], form[action*='/cart/add'] input[name='id']")) return true;
    } catch (_err) {}
    return false;
  }

  function isPropertyField(target) {
    if (!target || typeof target.matches !== "function") return false;
    try {
      return target.matches(
        "input[name^='properties['], select[name^='properties['], textarea[name^='properties['], input[name^='name_'], input[name^='Name_'], textarea[name^='name_'], textarea[name^='Name_']"
      );
    } catch (_err) {
      return false;
    }
  }

  function isQuantityField(target) {
    if (!target || typeof target.matches !== "function") return false;
    try {
      if (target.matches("input[name='quantity']")) return true;
      if (target.matches("quantity-input input, .quantity__input")) return true;
    } catch (_err) {}
    return false;
  }

  function applyNamedPreset(baseConfig, presetName, maxDepth) {
    var out = mergeObjects({}, baseConfig || {});
    var presets = normalizeLookupMap((out && out.presets && typeof out.presets === "object") ? out.presets : {});
    var visited = {};
    var depth = 0;
    var current = String(presetName || "").trim().toLowerCase();
    var depthLimit = Number(maxDepth);
    if (!isFinite(depthLimit) || depthLimit < 1) depthLimit = 8;

    while (current && depth < depthLimit) {
      if (visited[current]) break;
      visited[current] = true;
      depth += 1;

      var presetCfg = presets[current];
      if (!presetCfg) break;

      if (typeof presetCfg === "string") {
        current = String(presetCfg || "").trim().toLowerCase();
        continue;
      }

      if (typeof presetCfg !== "object" || Array.isArray(presetCfg)) break;

      out = mergeObjects(out, presetCfg);
      var nextPreset = String(presetCfg.preset || "").trim().toLowerCase();
      current = nextPreset || "";
    }

    return out;
  }

  function applyPresetMapping(baseConfig, mapping) {
    if (mapping == null) return mergeObjects({}, baseConfig || {});
    if (typeof mapping === "string") {
      return applyNamedPreset(baseConfig, mapping, 8);
    }
    if (typeof mapping !== "object" || Array.isArray(mapping)) {
      return mergeObjects({}, baseConfig || {});
    }

    var merged = mergeObjects(baseConfig || {}, mapping);
    if (mapping.preset) {
      merged = applyNamedPreset(merged, mapping.preset, 8);
    }
    if (merged && Object.prototype.hasOwnProperty.call(merged, "preset")) {
      delete merged.preset;
    }
    return merged;
  }

  function resolveSportScopedPreset(mapping, selectedSport, baseConfig) {
    if (mapping == null) return null;
    if (typeof mapping !== "object" || Array.isArray(mapping)) return mapping;

    var selectedSportKey = normalizeSportKey(selectedSport);
    if (selectedSportKey) {
      var aliases = normalizeLookupMap(baseConfig && baseConfig.sportAliases);
      var canonicalSport = aliases[selectedSportKey] || selectedSportKey;
      var presetBySport = normalizeLookupMap(
        (mapping.presetBySport && typeof mapping.presetBySport === "object") ? mapping.presetBySport : {}
      );
      if (Object.prototype.hasOwnProperty.call(presetBySport, canonicalSport)) {
        return presetBySport[canonicalSport];
      }
      if (Object.prototype.hasOwnProperty.call(presetBySport, selectedSportKey)) {
        return presetBySport[selectedSportKey];
      }
    }

    if (Object.prototype.hasOwnProperty.call(mapping, "defaultPreset")) return mapping.defaultPreset;
    if (Object.prototype.hasOwnProperty.call(mapping, "preset")) return mapping.preset;
    if (Object.prototype.hasOwnProperty.call(mapping, "default")) return mapping.default;
    return mapping;
  }

  function resolveProductTypeMapping(baseConfig, type, selectedSport) {
    var typesMap = normalizeLookupMap((baseConfig && baseConfig.productTypes && typeof baseConfig.productTypes === "object")
      ? baseConfig.productTypes
      : {});
    var typeKey = String(type || "").trim().toLowerCase();
    if (!typeKey || !typesMap[typeKey]) return null;

    var typeCfg = typesMap[typeKey];
    if (typeCfg == null) return null;
    var mapped = resolveSportScopedPreset(typeCfg, selectedSport, baseConfig);
    if (mapped != null) return mapped;

    // Convention-over-configuration fallback:
    // if preset "<sport>_<type>" exists, use it automatically.
    var presets = normalizeLookupMap((baseConfig && baseConfig.presets && typeof baseConfig.presets === "object")
      ? baseConfig.presets
      : {});
    var sportKey = normalizeSportKey(selectedSport || "");
    var candidate = (sportKey ? (sportKey + "_" + typeKey) : "");
    if (candidate && Object.prototype.hasOwnProperty.call(presets, candidate)) {
      return candidate;
    }
    return null;
  }

  function inferProductTypeFromHandle(handle, baseConfig) {
    var h = String(handle || "").trim().toLowerCase();
    if (!h) return "";

    var candidates = {};
    var productTypes = normalizeLookupMap((baseConfig && baseConfig.productTypes && typeof baseConfig.productTypes === "object")
      ? baseConfig.productTypes
      : {});
    Object.keys(productTypes).forEach(function (key) { candidates[key] = true; });

    var typeToPreset = normalizeLookupMap((baseConfig && baseConfig.productTypeToPreset && typeof baseConfig.productTypeToPreset === "object")
      ? baseConfig.productTypeToPreset
      : {});
    Object.keys(typeToPreset).forEach(function (key) { candidates[key] = true; });

    var types = Object.keys(candidates).filter(Boolean).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < types.length; i += 1) {
      var t = String(types[i] || "").trim().toLowerCase();
      if (!t) continue;
      if (h === t) return t;
      if (h.indexOf(t + "-") === 0) return t;
      if (h.indexOf("-" + t) === h.length - (t.length + 1)) return t;
      if (h.indexOf("-" + t + "-") !== -1) return t;
    }
    return "";
  }

  function resolveRuntimeConfig(config) {
    var resolved = mergeObjects({}, config);
    var handle = String(config.productHandle || detectProductHandle() || "").trim().toLowerCase();
    var type = String(config.productType || detectProductType() || "").trim().toLowerCase();
    if (!type && handle) {
      type = inferProductTypeFromHandle(handle, resolved);
    }
    var selectedSport = resolveVariantSportValue(resolved, {});
    var useMetafields = config && config.useMetafieldPreset === true;
    var explicitPreset = String(config.productPreset || "").trim().toLowerCase();
    if (!explicitPreset) {
      var globalPreset = String(
        window.SP3D_PREVIEW_PRODUCT_PRESET ||
        window.SP3D_PRODUCT_PRESET ||
        window.SP3D_PREVIEW_PRESET ||
        ""
      ).trim().toLowerCase();
      if (globalPreset) explicitPreset = globalPreset;
    }
    var metafieldPreset = useMetafields ? detectProductPreset() : "";
    var defaultDesign = String((config && config.defaults && config.defaults.design) || "tag").trim().toLowerCase();

    if (handle && resolved.products && resolved.products[handle]) {
      var productMapping = resolveSportScopedPreset(resolved.products[handle], selectedSport, resolved);
      resolved = applyPresetMapping(resolved, productMapping);
    } else {
      var productTypeMapping = resolveProductTypeMapping(resolved, type, selectedSport);
      if (productTypeMapping != null) {
        resolved = applyPresetMapping(resolved, productTypeMapping);
      } else if (type && resolved.productTypeToPreset && resolved.productTypeToPreset[type]) {
        resolved = applyPresetMapping(resolved, resolved.productTypeToPreset[type]);
      } else if (type && resolved.productTypeToSport && resolved.productTypeToSport[type]) {
        var sportMapping = resolved.productTypeToSport[type];
        if (sportMapping && typeof sportMapping === "object" && !Array.isArray(sportMapping)) {
          resolved = applyPresetMapping(resolved, sportMapping);
        } else {
          resolved.sport = String(sportMapping);
        }
      }

      if (type) {
        var presetSportKey = normalizeSportKey(selectedSport || resolved.sport || "");
        var presetCandidate = (presetSportKey ? (presetSportKey + "_" + type) : "");
        var knownPresets = normalizeLookupMap((resolved.presets && typeof resolved.presets === "object") ? resolved.presets : {});
        if (presetCandidate && Object.prototype.hasOwnProperty.call(knownPresets, presetCandidate)) {
          resolved = applyNamedPreset(resolved, presetCandidate, 8);
        }
      }
    }

    // Universal fallback: use Shopify product type as design key only when that type is
    // known by config. This avoids locale values like "Étiqueter" overriding "tag".
    if (type) {
      var knownTypes = {};
      Object.keys(normalizeLookupMap(resolved.productTypes)).forEach(function (key) { knownTypes[key] = true; });
      Object.keys(normalizeLookupMap(resolved.productTypeToPreset)).forEach(function (key) { knownTypes[key] = true; });
      Object.keys(normalizeLookupMap(resolved.productTypeToSport)).forEach(function (key) { knownTypes[key] = true; });

      var normalizedType = String(type || "").trim().toLowerCase();
      var cleanedType = normalizedType.replace(/[^a-z0-9_-]/g, "");
      var matchedType = "";
      if (knownTypes[normalizedType]) matchedType = normalizedType;
      else if (cleanedType && knownTypes[cleanedType]) matchedType = cleanedType;

      var currentDesign = String(resolved.design || "").trim().toLowerCase();
      if (matchedType && (!currentDesign || currentDesign === defaultDesign)) {
        resolved.design = matchedType;
      }
    }

    var finalPreset = explicitPreset || metafieldPreset;
    if (finalPreset) {
      resolved = applyNamedPreset(resolved, finalPreset, 8);
    }
    if (resolved && Object.prototype.hasOwnProperty.call(resolved, "preset")) {
      delete resolved.preset;
    }

    return resolved;
  }

  function valueFromElement(el) {
    if (!el) return "";
    if (el.type === "radio" || el.type === "checkbox") return el.checked ? (el.value || "").trim() : "";
    if (typeof el.value === "string" && el.value.trim()) return el.value.trim();
    var dv = el.getAttribute("data-value");
    if (dv && dv.trim()) return dv.trim();
    return (el.textContent || "").trim();
  }

  function firstResolvedValue(selectors) {
    var list = toArray(selectors);
    for (var i = 0; i < list.length; i += 1) {
      var selector = list[i];
      if (!selector || typeof selector !== "string") continue;
      var nodes = [];
      try {
        nodes = document.querySelectorAll(selector);
      } catch (_err) {
        continue;
      }
      for (var j = 0; j < nodes.length; j += 1) {
        var value = valueFromElement(nodes[j]);
        if (value) return value;
      }
    }
    return "";
  }

  function resolveClassicColors(rawValue, config) {
    var parts = String(rawValue || "").split("-").map(function (p) { return p.trim(); }).filter(Boolean);
    if (parts.length < 3) return null;
    var main = normalizeColorOrEmpty(parts[0], "text_main_color", config);
    var outline1 = normalizeColorOrEmpty(parts[1], "outline1_color", config);
    var outline2 = normalizeColorOrEmpty(parts[2], "outline2_color", config);
    if (!main || !outline1 || !outline2) return null;
    return {
      text_main_color: main,
      outline1_color: outline1,
      outline2_color: outline2
    };
  }

  // What PrintFlow decides per design (3D server GET <apiUrl>/design?sku=…): fixed colours
  // (app/fixed_colors.py), required fields, zones. Loaded once per SKU; until it arrives the
  // server still applies the fixed colours to the render.
  var DESIGN_INFO = {};
  // a page without a variant SKU (home page « See your name in 3D ») asks by model + sport
  function designQuery(payload) {
    if (payload.sku) return "sku=" + encodeURIComponent(payload.sku);
    if (payload.model && payload.sport) return "model=" + encodeURIComponent(payload.model) + "&sport=" + encodeURIComponent(payload.sport);
    return "";
  }
  function designInfo(sku, config) {
    if (!sku) return null;
    if (Object.prototype.hasOwnProperty.call(DESIGN_INFO, sku)) return DESIGN_INFO[sku];
    DESIGN_INFO[sku] = null;
    var base = String((config && config.apiUrl) || "").replace(/\/+$/, "");
    if (!base) return null;
    fetch(base + "/design?" + (sku.indexOf("=") > -1 ? sku : "sku=" + encodeURIComponent(sku)))
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (info) {
        DESIGN_INFO[sku] = info || {};
        document.dispatchEvent(new CustomEvent("sp3d:design-info", { detail: { sku: sku } }));
      })
      .catch(function () { DESIGN_INFO[sku] = {}; });
    return null;
  }

  function buildPayload(config) {
    var primarySportCtx = resolveSportConfig(config, config.sport);
    var fields = primarySportCtx.fields || {};
    var payloadKeys = collectPayloadKeys(config);
    var payload = Object.assign({}, config.defaults, primarySportCtx.defaults || {});
    var resolved = {};
    var explicitColorKeys = {};

    Object.keys(fields).forEach(function (key) {
      var value = firstResolvedValue(fields[key]);
      if (value !== "") resolved[key] = value;
    });
    resolved = applyPropertyFallbacks(resolved, config);
    function markExplicitResolvedColors() {
      COLOR_KEYS.forEach(function (key) {
        if (resolved[key] !== undefined && String(resolved[key]).trim() !== "") {
          explicitColorKeys[key] = true;
        }
      });
    }
    markExplicitResolvedColors();

    payloadKeys.forEach(function (key) {
      if (resolved[key] !== undefined) payload[key] = resolved[key];
    });

    var variantSportValue = resolveVariantSportValue(config, resolved);
    var variantDesignValue = resolveVariantDesignValue(config);

    payload.sport = normalizeSport(
      variantSportValue || config.sport || (config.defaults && config.defaults.sport),
      config
    );
    var selectedSportCtx = resolveSportConfig(config, payload.sport);
    var selectedSportDefaults = selectedSportCtx.defaults || {};
    var selectedSportFields = selectedSportCtx.fields || {};
    Object.keys(selectedSportFields).forEach(function (key) {
      if (resolved[key] !== undefined) return;
      var value = firstResolvedValue(selectedSportFields[key]);
      if (value !== "") resolved[key] = value;
    });
    markExplicitResolvedColors();
    payloadKeys.forEach(function (key) {
      if (resolved[key] === undefined && selectedSportDefaults[key] !== undefined) {
        payload[key] = selectedSportDefaults[key];
      }
    });
    payload.model = normalizeDesign(
      resolved.design || config.design || payload.design,
      config.defaults && config.defaults.design
    );
    payload.design = normalizeDesign(
      variantDesignValue,
      config.defaults && config.defaults.design
    );

    function directFieldValue(key) {
      var selectedValue = firstResolvedValue(selectedSportFields[key]);
      if (selectedValue !== "") return selectedValue;
      return firstResolvedValue(fields[key]);
    }

    if (!resolved.text_02 && payload.sport === "hockey" && fields.text_02_hockey) {
      var hockeyText02 = firstResolvedValue(fields.text_02_hockey);
      if (hockeyText02) payload.text_02 = hockeyText02;
    }

    var explicitDraftName = directFieldValue("name");
    var explicitDraftText02 = directFieldValue("text_02");
    var explicitDraftText03 = directFieldValue("text_03");
    var explicitDraftText04 = directFieldValue("text_04");
    var explicitDraftBackText = directFieldValue("back_text");
    if (resolved.name_1 && !explicitDraftName) {
      payload.name = resolved.name_1;
    }
    if (!explicitDraftText02 && resolved.text_02_1) payload.text_02 = resolved.text_02_1;
    if (!explicitDraftText03 && resolved.text_03_1) payload.text_03 = resolved.text_03_1;
    if (!explicitDraftText04 && resolved.text_04_1) payload.text_04 = resolved.text_04_1;
    if (!explicitDraftBackText && resolved.back_text_1) payload.back_text = resolved.back_text_1;

    var classicColors = resolved.classic_colors || "";
    if (classicColors) {
      var parsed = resolveClassicColors(classicColors, config);
      if (parsed) {
        payload.text_main_color = parsed.text_main_color;
        payload.outline1_color = parsed.outline1_color;
        payload.outline2_color = parsed.outline2_color;
        explicitColorKeys.text_main_color = true;
        explicitColorKeys.outline1_color = true;
        explicitColorKeys.outline2_color = true;
      }
    }

    payload.name = cleanText(payload.name, config.limits.name);
    // every design: a space inside the name is a no-break space, so the 3D server
    // never takes a compound first name's second word for the next line
    if (payload.name) {
      payload.name = protectTagNameSpacing(payload.name);
    }
    payload.back_text = cleanText(payload.back_text, config.limits.back_text);
    if (!payload.back_text) payload.back_text = payload.name;
    payloadKeys.forEach(function (key) {
      if (/^text_\d{2}$/.test(key)) payload[key] = cleanText(payload[key], config.limits[key] || config.limits.back_text);
    });
    payload.font = normalizeFont(payload.font, config);
    // SKU of the variant on screen: the 3D server resolves family + design from it
    // (PrintFlow catalogue); the model / design / sport fields stay as a fallback
    var skuMap = (config && config.variantSkus) || (window.SP3D_PREVIEW_CONFIG && window.SP3D_PREVIEW_CONFIG.variantSkus) || {};
    var variantId = detectSelectedVariantId();
    if (variantId && skuMap[variantId]) payload.sku = String(skuMap[variantId]).trim();
    payload.text_main_color = normalizeColorOrEmpty(payload.text_main_color, "text_main_color", config);
    payload.outline1_color = normalizeColorOrEmpty(payload.outline1_color, "outline1_color", config);
    payload.outline2_color = normalizeColorOrEmpty(payload.outline2_color, "outline2_color", config);
    payload.text_02_main_color = normalizeColorOrEmpty(payload.text_02_main_color, "text_02_main_color", config);
    payload.text_02_outline1_color = normalizeColorOrEmpty(payload.text_02_outline1_color, "text_02_outline1_color", config);
    payload.text_02_outline2_color = normalizeColorOrEmpty(payload.text_02_outline2_color, "text_02_outline2_color", config);
    if (!resolved.text_02_main_color && payload.text_main_color) {
      payload.text_02_main_color = payload.text_main_color;
      if (explicitColorKeys.text_main_color) explicitColorKeys.text_02_main_color = true;
    }
    if (!resolved.text_02_outline1_color && payload.outline1_color) {
      payload.text_02_outline1_color = payload.outline1_color;
      if (explicitColorKeys.outline1_color) explicitColorKeys.text_02_outline1_color = true;
    }
    if (!resolved.text_02_outline2_color && payload.outline2_color) {
      payload.text_02_outline2_color = payload.outline2_color;
      if (explicitColorKeys.outline2_color) explicitColorKeys.text_02_outline2_color = true;
    }
    payload.back_text_color = normalizeColorOrEmpty(payload.back_text_color, "back_text_color", config);
    payload.back_ball_color = normalizeColorOrEmpty(payload.back_ball_color, "back_ball_color", config);
    payload.ball_color = normalizeColorOrEmpty(payload.ball_color, "ball_color", config);
    payload.stitches_color = normalizeColorOrEmpty(payload.stitches_color, "stitches_color", config);

    COLOR_KEYS.forEach(function (key) {
      if (!explicitColorKeys[key]) {
        delete payload[key];
        return;
      }
      if (payload[key] === undefined || payload[key] === null || payload[key] === "") {
        delete payload[key];
      }
    });

    // customer colour zones (snippets/jne-zone-picker.liquid): "<role>_color" -> MAT_<ROLE>.
    // Applied last: the cleanup above drops known colour keys (ball_color...) the
    // old fields did not set, which would erase a zone choice on that same key.
    document.querySelectorAll("[data-sp3d-zone-key]").forEach(function (el) {
      var zoneHex = normalizeHex(el.getAttribute("data-hex"));
      if (el.value && zoneHex) payload[el.getAttribute("data-sp3d-zone-key")] = zoneHex;
    });

    // customer choices (snippets/jne-choice-picker.liquid): choice_<slot> = option key
    document.querySelectorAll("[data-sp3d-choice]").forEach(function (el) {
      if (el.value) payload["choice_" + el.getAttribute("data-sp3d-choice")] = el.value;
    });

    // PrintFlow fixed colours: a first-line element keeps its own colour whatever the
    // customer picked (their choice was copied to the next line above, e.g. the number)
    var info = designInfo(designQuery(payload), config);
    // ... only for a ready-made combo: with « Your own colors » the customer colours the name itself
    // and the number has its own tabs (snippets/jne-zone-picker.liquid, 2026-10-23)
    var modeInput = document.querySelector("[data-jne-color-picker] input[name='properties[Classic Colors]']:checked");
    var cpRoot = document.querySelector("[data-jne-color-picker]");
    var ownColors = !!(modeInput && cpRoot && modeInput.value === cpRoot.getAttribute("data-custom-value"));
    // the design's own element colours (PrintFlow zones) for every zone the page did not send —
    // a page without the colour picker (home page « See your name in 3D ») otherwise left the
    // number in the name's colour copied above instead of its own white (2026-10-24). A line that
    // follows the name (text_0N_* keys) keeps that copy, as on the product page.
    ((info && info.zones) || []).forEach(function (z) {
      var zoneHex = z && normalizeHex(z.default);
      if (!zoneHex || !/_color$/.test(z.key || "") || /^text_0\d_/.test(z.key)) return;
      if (!document.querySelector("[data-sp3d-zone-key='" + z.key + "']")) payload[z.key] = zoneHex;
    });
    var fixedColors = ownColors ? {} : ((info && info.fixed_colors) || {});
    if (ownColors && info && info.fixed_colors && Object.keys(info.fixed_colors).length) payload.jne_own_colors_color = "#000001";   // the server skips them too
    Object.keys(fixedColors).forEach(function (key) {
      var fixedHex = normalizeHex(fixedColors[key]);
      if (/_color$/.test(key) && fixedHex) payload[key] = fixedHex;
    });

    return payload;
  }

  function getFingerprint(payload) {
    var base = collectPayloadKeysFromPayload(payload).map(function (key) { return payload[key] || ""; }).join("|");
    var teamNamesPart = Array.isArray(payload.team_names) ? payload.team_names.join("^") : "";
    return base + "|" + teamNamesPart;
  }

  function clonePayload(payload) {
    var copy = Object.assign({}, payload);
    if (Array.isArray(payload && payload.team_names)) {
      copy.team_names = payload.team_names.slice();
    }
    return copy;
  }

  function haveSameKeys(a, b, keys) {
    if (!a || !b) return false;
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var av = a[key];
      var bv = b[key];
      if (Array.isArray(av) || Array.isArray(bv)) {
        var aa = Array.isArray(av) ? av : [];
        var bb = Array.isArray(bv) ? bv : [];
        if (aa.length !== bb.length) return false;
        for (var j = 0; j < aa.length; j += 1) {
          if (String(aa[j] || "") !== String(bb[j] || "")) return false;
        }
        continue;
      }
      if ((av || "") !== (bv || "")) return false;
    }
    return true;
  }

  function hexToRgbaFactors(value) {
    var hex = normalizeHex(value);
    if (!hex) return [1, 1, 1, 1];
    return [
      parseInt(hex.slice(1, 3), 16) / 255,
      parseInt(hex.slice(3, 5), 16) / 255,
      parseInt(hex.slice(5, 7), 16) / 255,
      1
    ];
  }

  function getWatchedSelectors(config) {
    var fields = {};
    fields = mergeFieldMap(fields, resolveSportConfig(config, config.sport).fields || {});

    var sportsMap = resolveSportsMap(config);
    Object.keys(sportsMap).forEach(function (sportKey) {
      if (sportKey === "default" || sportKey === "__default__" || sportKey === "*") return;
      var ctx = resolveSportConfig(config, sportKey);
      fields = mergeFieldMap(fields, ctx.fields || {});
    });

    var selectors = [];
    Object.keys(fields).forEach(function (key) {
      toArray(fields[key]).forEach(function (selector) {
        if (typeof selector === "string" && selector.trim()) selectors.push(selector.trim());
      });
    });
    return selectors;
  }

  function matchesAnySelector(target, selectors) {
    if (!selectors.length) return true;
    if (!target || typeof target.matches !== "function") return false;
    for (var i = 0; i < selectors.length; i += 1) {
      try {
        if (target.matches(selectors[i]) || target.closest(selectors[i])) return true;
      } catch (_err) {}
    }
    return false;
  }

  function elementMatchesOrContainsSelector(node, selectors) {
    if (!node || node.nodeType !== 1) return false;
    if (matchesAnySelector(node, selectors)) return true;
    for (var i = 0; i < selectors.length; i += 1) {
      var selector = selectors[i];
      try {
        if (node.querySelector && node.querySelector(selector)) return true;
      } catch (_err) {}
    }
    return false;
  }

  function mutationTouchesWatchedSelectors(mutations, selectors) {
    if (!selectors.length) return true;
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (elementMatchesOrContainsSelector(mutation.target, selectors)) return true;

      var added = mutation.addedNodes || [];
      for (var j = 0; j < added.length; j += 1) {
        if (elementMatchesOrContainsSelector(added[j], selectors)) return true;
      }

      var removed = mutation.removedNodes || [];
      for (var k = 0; k < removed.length; k += 1) {
        if (elementMatchesOrContainsSelector(removed[k], selectors)) return true;
      }
    }
    return false;
  }

  function install(runtimeConfig) {
    var config = resolveRuntimeConfig(mergeObjects({}, runtimeConfig || DEFAULT_CONFIG));
    config.productTypeToSport = normalizeLookupMap(config.productTypeToSport);
    config.productTypeToPreset = normalizeLookupMap(config.productTypeToPreset);
    config.products = normalizeLookupMap(config.products);
    config.presets = normalizeLookupMap(config.presets);
    config.sportAliases = normalizeLookupMap(config.sportAliases);
    config.sports = resolveSportsMap(config);
    config.allowedColors = toArray(config.allowedColors).map(normalizeHex).filter(Boolean);
    config.allowedSports = deriveAllowedSports(config);

    var viewer = document.querySelector(config.viewerSelector);
    var statusEl = document.querySelector(config.statusSelector);
    var button = config.updateButtonSelector ? document.querySelector(config.updateButtonSelector) : null;
    var addToCartBtn = document.querySelector("#sp3d-add-to-cart-btn");
    var previewLinkBtn = document.querySelector("#sp3d-preview-link-btn");
    var previewCard = (viewer && viewer.closest && viewer.closest("#sp3d-preview-card")) || document.querySelector("#sp3d-preview-card");
    var subtitleEl = document.querySelector("#sp3d-preview-subtitle");
    var teamNameEl = document.querySelector("#sp3d-team-name");
    var rotateHintEl = document.querySelector("#sp3d-rotate-hint");
    var shareBtn = document.querySelector("#sp3d-share-btn");
    if (!viewer || !statusEl) return;

    if (String(config.apiUrl).indexOf("TON_URL_NGROK") !== -1) {
      statusEl.textContent = "Replace TON_URL_NGROK in the script config.";
      return;
    }

    var watchedSelectors = getWatchedSelectors(config);
    var debounceTimer = null;
    var requestId = 0;
    var lastAppliedFingerprint = "";
    var inFlightFingerprint = "";
    var activeController = null;
    var activeModelBlobUrl = "";
    var lastGeometryPayload = null;
    var viewerHasModel = false;
    var addToCartThemeObserver = null;
    var teamFieldsObserver = null;
    var teamFieldsObservedForm = null;
    var teamFieldsObserverRetryCount = 0;
    var teamFieldsObserverRetryTimer = 0;
    var teamPreviewOptionNames = [];
    var autoRotateRafId = 0;
    var autoRotateLastTs = 0;
    var autoRotateDirection = 1;
    var autoRotateAzimuthDeg = NaN;
    var autoRotateRange = null;
    var autoRotatePausedUntilTs = 0;
    var stickyFallbackHandle = null;
    var lastAdaptiveFramingKey = "";
    var uiRuntime = {
      currentSport: config.sport,
      currentNamesCount: 0
    };
    var clickRuntime = {
      url: "",
      clickableCard: false,
      newTab: false,
      pointerActive: false,
      pointerMoved: false,
      startX: 0,
      startY: 0
    };

    // Visible strings come from the theme's locale files (window.SP3D_I18N, set in snippets-sp3d-preview)
    function i18n(key, fallback) {
      var dict = window.SP3D_I18N || {};
      return dict[key] || fallback;
    }

    function setStatus(message) {
      statusEl.textContent = message;
    }

    function setTeamName(names) {
      if (!teamNameEl) return;
      var count = Array.isArray(names) ? names.length : 0;
      if (!count) { teamNameEl.textContent = ""; return; }
      var label = count === 1 ? i18n("player", "player") : i18n("players", "players");
      var last = String(names[count - 1] || "").split(" ")[0];
      teamNameEl.textContent = count + " " + label + (last ? " · " + last.toUpperCase() : "");
    }

    function parseBoolean(value, fallback) {
      if (value === true || value === false) return value;
      var raw = String(value || "").trim().toLowerCase();
      if (!raw) return fallback;
      if (raw === "true" || raw === "1" || raw === "yes" || raw === "on") return true;
      if (raw === "false" || raw === "0" || raw === "no" || raw === "off") return false;
      return fallback;
    }

    function parseNumber(value, fallback) {
      var parsed = parseFloat(String(value));
      return isFinite(parsed) ? parsed : fallback;
    }

    function openClickthroughUrl(url, openNewTab) {
      var target = String(url || "").trim();
      if (!target) return;
      var isAllowed = /^https?:\/\//i.test(target) || /^\//.test(target) || /^mailto:/i.test(target) || /^tel:/i.test(target);
      if (!isAllowed) return;
      if (openNewTab) {
        window.open(target, "_blank", "noopener,noreferrer");
        return;
      }
      window.location.href = target;
    }

    function isInteractiveTarget(target) {
      if (!target || !target.closest) return false;
      return !!target.closest(
        "#sp3d-add-to-cart-btn, #sp3d-preview-link-btn, a, button, input, textarea, select, option, label, summary, details, [role='button']"
      );
    }

    function isHockeyLikeSport(sportKey) {
      var sport = normalizeSport(sportKey, config);
      return sport === "hockey";
    }

    function applyUiSettings() {
      var ui = config.ui || {};
      var compactMode = parseBoolean(ui.compactMode, false);
      var showAddToCart = parseBoolean(ui.showAddToCartButton, true);
      var clickthrough = ui.clickthrough || {};
      var clickUrl = String(clickthrough.url || "").trim();
      var showLinkButton = parseBoolean(clickthrough.showButton, false);
      var clickableCard = parseBoolean(clickthrough.clickableCard, false);
      var openInNewTab = parseBoolean(clickthrough.newTab, false);
      var linkLabel = String(clickthrough.buttonLabel || "Open link").trim() || "Open link";

      if (previewCard) {
        if (compactMode) {
          previewCard.classList.add("sp3d-preview-card--compact");
        } else {
          previewCard.classList.remove("sp3d-preview-card--compact");
        }
        if (clickableCard && clickUrl) {
          previewCard.classList.add("sp3d-preview-card--clickable");
        } else {
          previewCard.classList.remove("sp3d-preview-card--clickable");
        }
      }

      if (subtitleEl) {
        var subtitle = String(ui.subtitle || "").trim();
        if (subtitle) {
          subtitleEl.textContent = subtitle;
          subtitleEl.style.display = "";
        } else {
          subtitleEl.textContent = "";
          subtitleEl.style.display = "none";
        }
      }

      if (addToCartBtn) {
        addToCartBtn.style.display = showAddToCart ? "" : "none";
      }

      if (previewLinkBtn) {
        previewLinkBtn.style.display = showLinkButton ? "" : "none";
        previewLinkBtn.textContent = linkLabel;
        previewLinkBtn.disabled = !clickUrl;
        if (!clickUrl) {
          previewLinkBtn.setAttribute("aria-disabled", "true");
          previewLinkBtn.title = "Set Preview click URL to enable this button.";
        } else {
          previewLinkBtn.removeAttribute("aria-disabled");
          previewLinkBtn.removeAttribute("title");
        }
      }

      clickRuntime.url = clickUrl;
      clickRuntime.clickableCard = !!(clickableCard && clickUrl);
      clickRuntime.newTab = openInNewTab;
    }

    function computeViewerHeightPx() {
      var ui = config.ui || {};
      var viewerWindow = ui.viewerWindow || {};
      var dynamicCfg = viewerWindow.dynamicByNames || {};
      var compactMode = parseBoolean(ui.compactMode, false);
      var isMobile = !!(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);

      var fallbackDesktop = compactMode ? 180 : 220;
      var fallbackMobile = compactMode ? 140 : 170;
      var fallbackMin = compactMode ? 110 : 120;
      var fallbackMax = compactMode ? 460 : 520;

      var desktopHeight = parseNumber(viewerWindow.desktopHeightPx, fallbackDesktop);
      var mobileHeight = parseNumber(viewerWindow.mobileHeightPx, fallbackMobile);
      var minHeight = parseNumber(viewerWindow.minHeightPx, fallbackMin);
      var maxHeight = parseNumber(viewerWindow.maxHeightPx, fallbackMax);
      if (maxHeight < minHeight) maxHeight = minHeight;

      var targetHeight = isMobile ? mobileHeight : desktopHeight;
      var dynamicEnabled = parseBoolean(dynamicCfg.enabled, false);
      if (dynamicEnabled) {
        var nhlOnly = parseBoolean(dynamicCfg.nhlOnly, false);
        if (!nhlOnly || isHockeyLikeSport(uiRuntime.currentSport)) {
          var perNamePx = parseNumber(dynamicCfg.perNamePx, 8);
          var startAtName = parseInt(String(dynamicCfg.startAtName || 2), 10);
          if (!isFinite(startAtName) || startAtName < 1) startAtName = 2;
          var extraNames = Math.max(0, uiRuntime.currentNamesCount - startAtName + 1);
          targetHeight += extraNames * perNamePx;
        }
      }

      return Math.round(clamp(targetHeight, minHeight, maxHeight));
    }

    function refreshViewerWindowSize() {
      if (!viewer) return;
      viewer.style.height = String(computeViewerHeightPx()) + "px";
      viewer.style.aspectRatio = "auto";
    }

    function refreshUiRuntimeStateFromForm() {
      uiRuntime.currentSport = normalizeSport(config.sport, config);
      uiRuntime.currentNamesCount = 0;
      try {
        var payload = buildPayload(config);
        uiRuntime.currentSport = payload.sport || uiRuntime.currentSport;
        var names = collectTeamPreviewNames(config, resolveTeamPreviewOptionNames(), findAddToCartForm());
        uiRuntime.currentNamesCount = names.length;
      } catch (_error) {}
      refreshViewerWindowSize();
      maybeRefreshAdaptiveFraming(false, false);
    }

    function computeAdaptiveFramingKey() {
      var isMobile = !!(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
      var sport = normalizeSport(uiRuntime.currentSport, config);
      var namesCount = parseInt(String(uiRuntime.currentNamesCount || 0), 10);
      if (!isFinite(namesCount) || namesCount < 0) namesCount = 0;
      return [sport, String(namesCount), isMobile ? "mobile" : "desktop"].join("|");
    }

    function maybeRefreshAdaptiveFraming(resetPose, force) {
      if (!viewer) return;
      var key = computeAdaptiveFramingKey();
      if (!force && key === lastAdaptiveFramingKey) return;
      lastAdaptiveFramingKey = key;
      applyViewerFraming(!!resetPose);
    }

    function isStickyPreviewEnabled() {
      if (!previewCard) return false;
      var attr = String(previewCard.getAttribute("data-sticky-preview") || "").toLowerCase();
      if (attr === "false" || attr === "0") return false;
      return !previewCard.classList.contains("sp3d-preview-card--not-sticky");
    }

    function initStickyFallback() {
      if (!previewCard || !isStickyPreviewEnabled() || !window || !window.addEventListener) return;

      var placeholder = null;
      var isFixed = false;
      var startScrollY = 0;
      var topOffset = 12;
      var ticking = false;
      var boundaryContainer = previewCard.parentElement;

      function getScrollY() {
        return window.scrollY || window.pageYOffset || 0;
      }

      function readTopOffsetPx() {
        var styles = window.getComputedStyle ? window.getComputedStyle(previewCard) : null;
        var parsed = parseFloat(styles && styles.top ? styles.top : "12");
        return isFinite(parsed) ? parsed : 12;
      }

      function ensurePlaceholder() {
        if (placeholder && placeholder.parentNode) return;
        placeholder = document.createElement("div");
        placeholder.style.display = "none";
        previewCard.parentNode.insertBefore(placeholder, previewCard);
      }

      function getOuterHeightPx(el) {
        if (!el) return 0;
        var rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
        var height = rect ? rect.height : (el.offsetHeight || 0);
        var styles = window.getComputedStyle ? window.getComputedStyle(el) : null;
        var marginTop = parseFloat(styles && styles.marginTop ? styles.marginTop : "0");
        var marginBottom = parseFloat(styles && styles.marginBottom ? styles.marginBottom : "0");
        if (!isFinite(marginTop)) marginTop = 0;
        if (!isFinite(marginBottom)) marginBottom = 0;
        return Math.max(0, height + marginTop + marginBottom);
      }

      function updateStartScrollY() {
        topOffset = readTopOffsetPx();
        var rect = previewCard.getBoundingClientRect();
        startScrollY = getScrollY() + rect.top - topOffset;
      }

      function applyFixed() {
        ensurePlaceholder();
        if (!placeholder) return;

        var rect = previewCard.getBoundingClientRect();
        placeholder.style.display = "block";
        placeholder.style.width = rect.width + "px";
        placeholder.style.height = getOuterHeightPx(previewCard) + "px";
        previewCard.style.position = "fixed";
        previewCard.style.top = topOffset + "px";
        previewCard.style.left = rect.left + "px";
        previewCard.style.width = rect.width + "px";
        previewCard.style.zIndex = "50";
        isFixed = true;
      }

      function clearFixed() {
        if (!isFixed) return;
        if (placeholder) placeholder.style.display = "none";
        previewCard.style.position = "";
        previewCard.style.top = "";
        previewCard.style.left = "";
        previewCard.style.width = "";
        previewCard.style.zIndex = "";
        isFixed = false;
      }

      function updateNow() {
        topOffset = readTopOffsetPx();

        var scrollY = getScrollY();
        if (scrollY <= startScrollY + 1) {
          clearFixed();
          return;
        }

        var rect = previewCard.getBoundingClientRect();
        var cardHeight = previewCard.offsetHeight || rect.height || 0;
        var containerEnded = false;
        if (boundaryContainer && boundaryContainer.getBoundingClientRect) {
          var containerRect = boundaryContainer.getBoundingClientRect();
          containerEnded = containerRect.bottom <= topOffset + cardHeight + 2;
        }
        if (containerEnded) {
          clearFixed();
          return;
        }

        // Sticky is considered broken when:
        // - card stays below expected sticky top while scrolling down
        // - or card moves above sticky top before the container-end zone
        var stickySeemsBroken = rect.top > topOffset + 2 || rect.top < topOffset - 2;
        if (!isFixed && !stickySeemsBroken) return;
        applyFixed();
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          updateNow();
        });
      }

      function refresh() {
        updateStartScrollY();
        requestUpdate();
      }

      refresh();
      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", refresh);
      stickyFallbackHandle = { refresh: refresh };
    }

    function refreshTeamPreviewOptionNames() {
      teamPreviewOptionNames = readTeamPreviewOptionNamesFromLpoConfig(config);
      return teamPreviewOptionNames;
    }

    function resolveTeamPreviewOptionNames() {
      if (teamPreviewOptionNames.length) return teamPreviewOptionNames;
      return refreshTeamPreviewOptionNames();
    }

    function isTeamPreviewTrackedField(target) {
      if ((config.teamPreview || {}).enabled === false) return false;
      if (!target || !target.matches || !target.matches("input, textarea")) return false;
      var optionName = getPropertyOptionName(target);
      if (!optionName) return false;
      var teamFieldRegex = resolveTeamFieldNameRegex((config && config.teamPreview) || {});

      var optionNames = resolveTeamPreviewOptionNames();
      if (!optionNames.length) {
        var fallbackKey = normalizeTeamLookupKey(optionName);
        if (teamFieldRegex.test(fallbackKey)) return true;
        return fallbackKey.indexOf("name") !== -1 && /\d/.test(fallbackKey);
      }

      for (var i = 0; i < optionNames.length; i += 1) {
        if (teamOptionMatches(optionName, optionNames[i])) return true;
      }
      if (teamFieldRegex.test(normalizeTeamLookupKey(optionName))) return true;
      return false;
    }

    function appendTeamNamesToPayload(payload) {
      if (!payload || (config.teamPreview || {}).enabled === false) return payload;
      var form = findAddToCartForm();
      var names = [];
      // every design: a player's later lines (number...) travel with the name, not only on tags
      {
        var structuredEntries = collectStructuredTeamPreviewEntries(config, form);
        if (structuredEntries.length) {
          if (structuredEntries.length === 1) {
            var firstEntry = structuredEntries[0];
            payload.name = firstEntry.name || payload.name;
            payload.text_02 = firstEntry.text_02 || "";
            if (payload.name) {
              payload.name = cleanText(payload.name, config.limits.name);
              payload.name = protectTagNameSpacing(payload.name);
            }
            payload.text_02 = cleanText(payload.text_02, config.limits.text_02 || config.limits.back_text);
          } else {
            payload.name = "";
            payload.text_02 = "";
            payload.back_text = "";
          }
        }
        // "NAME TEXT_02": the name's own spaces are no-break spaces (MARIE EVE 23 -> MARIE EVE / 23)
        names = structuredEntries.map(function(entry) {
          var name = protectTagNameSpacing(String(entry.name || "").trim());
          return entry.text_02 ? (name + " " + entry.text_02) : name;
        });
      }
      if (!names.length) {
        names = collectTeamPreviewNames(config, resolveTeamPreviewOptionNames(), form);
      }
      uiRuntime.currentNamesCount = names.length;
      setTeamName(names);
      if (names.length) {
        payload.team_names = names;
      } else if (payload.team_names !== undefined) {
        delete payload.team_names;
      }
      uiRuntime.currentSport = payload.sport || uiRuntime.currentSport;
      refreshViewerWindowSize();
      maybeRefreshAdaptiveFraming(false, false);
      return payload;
    }

    function splitOrbitParts(value) {
      var parts = String(value || "").trim().split(/\s+/).filter(Boolean);
      return [parts[0] || "0deg", parts[1] || "75deg", parts[2] || "120%"];
    }

    function withLockedVerticalAngle(value, angleDeg, fallbackRadius) {
      var parts = splitOrbitParts(value);
      var radius = parts[2] || fallbackRadius || "120%";
      return String(parts[0]) + " " + String(angleDeg) + "deg " + String(radius);
    }

    function parseDegToken(value) {
      var raw = String(value || "").trim().toLowerCase();
      if (!raw || raw === "auto") return NaN;
      var withUnit = raw.match(/^(-?\d+(?:\.\d+)?)deg$/);
      if (withUnit) return parseFloat(withUnit[1]);
      var plain = parseFloat(raw);
      return isFinite(plain) ? plain : NaN;
    }

    function clamp(value, minValue, maxValue) {
      return Math.max(minValue, Math.min(maxValue, value));
    }

    function parsePercentToken(value) {
      var raw = String(value || "").trim().toLowerCase();
      if (!raw) return NaN;
      var withUnit = raw.match(/^(-?\d+(?:\.\d+)?)%$/);
      if (!withUnit) return NaN;
      return parseFloat(withUnit[1]);
    }

    function formatPercentToken(value, fallbackPercent) {
      var parsed = parseFloat(String(value));
      if (!isFinite(parsed)) parsed = parseFloat(String(fallbackPercent));
      if (!isFinite(parsed)) parsed = 100;
      return String(Math.round(parsed * 100) / 100) + "%";
    }

    function withOrbitRadiusPercent(value, radiusPercent, fallbackRadiusPercent) {
      var parts = splitOrbitParts(value);
      var fallback = parsePercentToken(parts[2]);
      if (!isFinite(fallback)) fallback = parseFloat(String(fallbackRadiusPercent));
      return String(parts[0]) + " " + String(parts[1]) + " " + formatPercentToken(radiusPercent, fallback);
    }

    function resolveAdaptiveOrbitRadiusPercent(baseOrbit, isMobile) {
      var framing = config.viewerFraming || {};
      var dynamicCfg = framing.dynamicZoom || {};
      if (parseBoolean(dynamicCfg.enabled, true) === false) {
        return parsePercentToken(splitOrbitParts(baseOrbit)[2]);
      }

      var singleDesktop = parseNumber(dynamicCfg.singleNameRadiusDesktopPercent, 92);
      var singleMobile = parseNumber(dynamicCfg.singleNameRadiusMobilePercent, 72);
      var stepDesktop = parseNumber(dynamicCfg.perExtraNameDesktopPercent, 11);
      var stepMobile = parseNumber(dynamicCfg.perExtraNameMobilePercent, 13);
      var maxExtra = parseNumber(dynamicCfg.maxExtraPercent, 170);
      var minDesktop = parseNumber(dynamicCfg.minRadiusDesktopPercent, 84);
      var minMobile = parseNumber(dynamicCfg.minRadiusMobilePercent, 60);
      var maxDesktop = parseNumber(dynamicCfg.maxRadiusDesktopPercent, 280);
      var maxMobile = parseNumber(dynamicCfg.maxRadiusMobilePercent, 320);
      var startAtName = parseInt(String(dynamicCfg.startAtName || 2), 10);
      if (!isFinite(startAtName) || startAtName < 1) startAtName = 2;

      var namesCount = parseInt(String(uiRuntime.currentNamesCount || 0), 10);
      if (!isFinite(namesCount) || namesCount < 1) namesCount = 1;
      var extraNames = Math.max(0, namesCount - startAtName + 1);

      var baseRadius = isMobile ? singleMobile : singleDesktop;
      var step = isMobile ? stepMobile : stepDesktop;
      var minRadius = isMobile ? minMobile : minDesktop;
      var maxRadius = isMobile ? maxMobile : maxDesktop;
      if (!isFinite(baseRadius)) baseRadius = parsePercentToken(splitOrbitParts(baseOrbit)[2]);
      if (!isFinite(baseRadius)) baseRadius = isMobile ? 72 : 92;
      if (!isFinite(step) || step < 0) step = isMobile ? 13 : 11;
      if (!isFinite(maxExtra) || maxExtra < 0) maxExtra = 170;
      if (!isFinite(minRadius)) minRadius = isMobile ? 60 : 84;
      if (!isFinite(maxRadius)) maxRadius = isMobile ? 320 : 280;
      if (maxRadius < minRadius) maxRadius = minRadius;

      var radius = baseRadius + Math.min(maxExtra, extraNames * step);
      return clamp(radius, minRadius, maxRadius);
    }

    function resolveAdaptiveOrbitRange(orbit, minOrbitValue, maxOrbitValue, targetRadius, isMobile) {
      var framing = config.viewerFraming || {};
      var dynamicCfg = framing.dynamicZoom || {};
      var minCfg = parseNumber(
        isMobile ? dynamicCfg.minRadiusMobilePercent : dynamicCfg.minRadiusDesktopPercent,
        isMobile ? 60 : 84
      );
      var maxCfg = parseNumber(
        isMobile ? dynamicCfg.maxRadiusMobilePercent : dynamicCfg.maxRadiusDesktopPercent,
        isMobile ? 320 : 280
      );
      if (!isFinite(minCfg)) minCfg = isMobile ? 60 : 84;
      if (!isFinite(maxCfg)) maxCfg = isMobile ? 320 : 280;
      if (maxCfg < minCfg) maxCfg = minCfg;

      var radiusWindow = parseNumber(dynamicCfg.radiusWindowPercent, 22);
      if (!isFinite(radiusWindow) || radiusWindow < 4) radiusWindow = 22;
      var halfWindow = radiusWindow / 2;

      var minRadius = clamp(targetRadius - halfWindow, minCfg, maxCfg);
      var maxRadius = clamp(targetRadius + halfWindow, minRadius + 2, maxCfg);

      return {
        orbit: withOrbitRadiusPercent(orbit, targetRadius, targetRadius),
        minOrbit: withOrbitRadiusPercent(minOrbitValue || orbit, minRadius, minRadius),
        maxOrbit: withOrbitRadiusPercent(maxOrbitValue || orbit, maxRadius, maxRadius)
      };
    }

    function buildLimitedAutoRotateRange(orbit, minOrbitValue, maxOrbitValue) {
      var framing = config.viewerFraming || {};
      var rotateCfg = framing.autoRotateLimited || {};
      if (rotateCfg.enabled === false) return null;

      var orbitParts = splitOrbitParts(orbit);
      var minParts = splitOrbitParts(minOrbitValue || orbit);
      var maxParts = splitOrbitParts(maxOrbitValue || orbit);
      var baseAz = parseDegToken(orbitParts[0]);
      var minAz = parseDegToken(minParts[0]);
      var maxAz = parseDegToken(maxParts[0]);

      if (!isFinite(minAz)) minAz = parseFloat(rotateCfg.minAzimuthDeg);
      if (!isFinite(maxAz)) maxAz = parseFloat(rotateCfg.maxAzimuthDeg);

      if (!isFinite(minAz) || !isFinite(maxAz)) {
        var center = isFinite(baseAz) ? baseAz : 0;
        minAz = center - 35;
        maxAz = center + 35;
      }

      if (minAz > maxAz) {
        var tmp = minAz;
        minAz = maxAz;
        maxAz = tmp;
      }

      return {
        minAzimuthDeg: minAz,
        maxAzimuthDeg: maxAz,
        polar: orbitParts[1],
        radius: orbitParts[2],
        initialAzimuthDeg: isFinite(baseAz) ? clamp(baseAz, minAz, maxAz) : (minAz + maxAz) / 2
      };
    }

    function setLimitedAutoRotateOrbit(azimuthDeg) {
      if (!autoRotateRange) return;
      viewer.setAttribute(
        "camera-orbit",
        String(azimuthDeg) + "deg " + String(autoRotateRange.polar) + " " + String(autoRotateRange.radius)
      );
    }

    function stopLimitedAutoRotate() {
      if (autoRotateRafId) cancelAnimationFrame(autoRotateRafId);
      autoRotateRafId = 0;
      autoRotateLastTs = 0;
      autoRotateRange = null;
    }

    function pauseLimitedAutoRotate() {
      var framing = config.viewerFraming || {};
      var rotateCfg = framing.autoRotateLimited || {};
      var pauseMs = parseInt(String(rotateCfg.pauseOnInteractionMs || 1200), 10);
      if (!isFinite(pauseMs) || pauseMs < 0) pauseMs = 1200;
      var now = (window.performance && typeof window.performance.now === "function")
        ? window.performance.now()
        : Date.now();
      autoRotatePausedUntilTs = now + pauseMs;
    }

    function stepLimitedAutoRotate(ts) {
      if (!autoRotateRange) return;

      var now = typeof ts === "number"
        ? ts
        : ((window.performance && typeof window.performance.now === "function") ? window.performance.now() : Date.now());

      if (!autoRotateLastTs) autoRotateLastTs = now;
      var deltaSec = Math.max(0, (now - autoRotateLastTs) / 1000);
      autoRotateLastTs = now;

      if (now >= autoRotatePausedUntilTs) {
        var framing = config.viewerFraming || {};
        var rotateCfg = framing.autoRotateLimited || {};
        var speed = parseFloat(rotateCfg.speedDegPerSec);
        if (!isFinite(speed) || speed <= 0) speed = 10;

        var next = autoRotateAzimuthDeg + speed * deltaSec * autoRotateDirection;
        if (next >= autoRotateRange.maxAzimuthDeg) {
          next = autoRotateRange.maxAzimuthDeg;
          autoRotateDirection = -1;
        } else if (next <= autoRotateRange.minAzimuthDeg) {
          next = autoRotateRange.minAzimuthDeg;
          autoRotateDirection = 1;
        }

        autoRotateAzimuthDeg = next;
        setLimitedAutoRotateOrbit(autoRotateAzimuthDeg);
      }

      autoRotateRafId = requestAnimationFrame(stepLimitedAutoRotate);
    }

    function startLimitedAutoRotate(orbit, minOrbitValue, maxOrbitValue) {
      var range = buildLimitedAutoRotateRange(orbit, minOrbitValue, maxOrbitValue);
      stopLimitedAutoRotate();
      if (!range) return;

      autoRotateRange = range;
      if (!isFinite(autoRotateAzimuthDeg)) autoRotateAzimuthDeg = range.initialAzimuthDeg;
      autoRotateAzimuthDeg = clamp(autoRotateAzimuthDeg, range.minAzimuthDeg, range.maxAzimuthDeg);
      setLimitedAutoRotateOrbit(autoRotateAzimuthDeg);

      autoRotateLastTs = 0;
      autoRotateRafId = requestAnimationFrame(stepLimitedAutoRotate);
    }

    function applyViewerFraming(resetPose) {
      var framing = config.viewerFraming || {};
      var isMobile = !!(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
      var orbit = isMobile ? (framing.mobileOrbit || framing.desktopOrbit) : (framing.desktopOrbit || framing.mobileOrbit);
      var lockVertical = Number(framing.lockVerticalAngleDeg);
      var hasLockedVertical = isFinite(lockVertical) && lockVertical > 0;
      var minOrbitValue = framing.minOrbit;
      var maxOrbitValue = framing.maxOrbit;

      if (hasLockedVertical) {
        orbit = withLockedVerticalAngle(orbit, lockVertical, "120%");
        minOrbitValue = withLockedVerticalAngle(minOrbitValue || orbit, lockVertical, "75%");
        maxOrbitValue = withLockedVerticalAngle(maxOrbitValue || orbit, lockVertical, "250%");
      }

      var targetRadius = resolveAdaptiveOrbitRadiusPercent(orbit, isMobile);
      if (isFinite(targetRadius)) {
        var adaptiveRange = resolveAdaptiveOrbitRange(orbit, minOrbitValue || orbit, maxOrbitValue || orbit, targetRadius, isMobile);
        orbit = adaptiveRange.orbit;
        minOrbitValue = adaptiveRange.minOrbit;
        maxOrbitValue = adaptiveRange.maxOrbit;
      }

      if (framing.cameraTarget) viewer.setAttribute("camera-target", String(framing.cameraTarget));
      if (orbit) viewer.setAttribute("camera-orbit", String(orbit));
      if (minOrbitValue) viewer.setAttribute("min-camera-orbit", String(minOrbitValue));
      if (maxOrbitValue) viewer.setAttribute("max-camera-orbit", String(maxOrbitValue));
      if (framing.minFieldOfView) viewer.setAttribute("min-field-of-view", String(framing.minFieldOfView));
      if (framing.maxFieldOfView) viewer.setAttribute("max-field-of-view", String(framing.maxFieldOfView));

      if (resetPose && typeof viewer.jumpCameraToGoal === "function") {
        viewer.jumpCameraToGoal();
      }

      startLimitedAutoRotate(orbit, minOrbitValue, maxOrbitValue);
    }

  function applyColorsToViewer(payload) {
    if (!viewer || !viewer.model || !Array.isArray(viewer.model.materials)) return false;
    var mats = viewer.model.materials;
    var byName = {};
    for (var i = 0; i < mats.length; i += 1) {
      if (mats[i] && mats[i].name) byName[mats[i].name] = mats[i];
    }

    function findMaterialByName(baseName) {
      if (!baseName) return null;
      if (byName[baseName]) return byName[baseName];
      var escaped = String(baseName).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      var pattern = new RegExp("^" + escaped + "(?:\\.\\d+)?$");
      var keys = Object.keys(byName);
      for (var k = 0; k < keys.length; k += 1) {
        var key = keys[k];
        if (pattern.test(key)) return byName[key];
      }
      return null;
    }

    var applied = false;
    // known keys, plus any customer zone key ("fx_001_color" -> MAT_FX_001)
    var zoneKeys = Object.keys(payload || {}).filter(function (k) { return /_color$/.test(k) && COLOR_KEYS.indexOf(k) === -1; });
    COLOR_KEYS.concat(zoneKeys).forEach(function (colorKey) {
      // a later line's own zone key ("zone_text_02_main_color") colours MAT_TEXT_02_MAIN
      var matName = MATERIAL_COLOR_MAP[colorKey] || ("MAT_" + colorKey.replace(/^zone_/, "").replace(/_color$/, "").toUpperCase());
      var mat = findMaterialByName(matName);
      if (!mat || !mat.pbrMetallicRoughness) return;
      var colorHex = normalizeHex(payload[colorKey]);
      if (!colorHex) return;
      var rgba = hexToRgbaFactors(colorHex);
      if (typeof mat.pbrMetallicRoughness.setBaseColorFactor === "function") {
        mat.pbrMetallicRoughness.setBaseColorFactor(rgba);
        applied = true;
          return;
        }
        if (mat.pbrMetallicRoughness.baseColorFactor) {
          mat.pbrMetallicRoughness.baseColorFactor = rgba;
          applied = true;
        }
      });

      return applied;
    }

    function scheduleUpdate(delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updatePreview, delay);
    }
    // the design's PrintFlow facts arrived (fixed colours...): rebuild the preview with them
    document.addEventListener("sp3d:design-info", function () { scheduleUpdate(50); });

    function findAddToCartForm() {
      var card = document.querySelector("#sp3d-preview-card");
      var closestForm = card && card.closest ? card.closest("form[data-type='add-to-cart-form']") : null;
      if (closestForm) return closestForm;
      return (
        document.querySelector("form[data-type='add-to-cart-form']") ||
        document.querySelector("form[action*='/cart/add']:not(.installment)")
      );
    }

    function isUsableSubmitControl(el) {
      if (!el) return false;
      if (el.disabled) return false;
      var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (style && (style.display === "none" || style.visibility === "hidden")) return false;
      if (el.offsetParent === null && (!el.getClientRects || !el.getClientRects().length)) return false;
      return true;
    }

    function findAddSubmitButton(form) {
      if (!form) return null;
      var candidates = [
        form.querySelector("button[name='add'][type='submit']"),
        form.querySelector("button[name='add']"),
        form.querySelector("button[type='submit']"),
        form.querySelector("input[name='add'][type='submit']"),
        form.querySelector("input[type='submit']")
      ];
      for (var i = 0; i < candidates.length; i += 1) {
        if (isUsableSubmitControl(candidates[i])) return candidates[i];
      }
      return candidates[0] || null;
    }

    function getControlLabel(control) {
      if (!control) return "";
      var tag = String(control.tagName || "").toLowerCase();
      if (tag === "input") return String(control.value || control.getAttribute("value") || "").trim();
      return String(control.textContent || "").trim();
    }

    function syncAddToCartButtonTheme() {
      if (!addToCartBtn) return;
      if (parseBoolean((config.ui || {}).showAddToCartButton, true) === false) return;
      var form = findAddToCartForm();
      var submitBtn = findAddSubmitButton(form);
      if (!submitBtn) return;

      addToCartBtn.className = "sp3d-add-to-cart-proxy sp3d-add-to-cart-fallback";

      var label = getControlLabel(submitBtn);
      if (label) addToCartBtn.textContent = label;

      var isDisabled = !!submitBtn.disabled || String(submitBtn.getAttribute("aria-disabled") || "").toLowerCase() === "true";
      addToCartBtn.disabled = isDisabled;
      if (isDisabled) {
        addToCartBtn.setAttribute("aria-disabled", "true");
      } else {
        addToCartBtn.removeAttribute("aria-disabled");
      }
    }

    function initAddToCartButtonSync() {
      syncAddToCartButtonTheme();
      var form = findAddToCartForm();
      if (!form || !window.MutationObserver) return;

      if (addToCartThemeObserver) addToCartThemeObserver.disconnect();
      addToCartThemeObserver = new MutationObserver(function () {
        syncAddToCartButtonTheme();
      });
      addToCartThemeObserver.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "disabled", "value", "aria-disabled"]
      });
    }

    function initTeamFieldsSyncObserver() {
      if ((config.teamPreview || {}).enabled === false) return;
      if (!window.MutationObserver) return;

      var form = findAddToCartForm();
      if (!form) {
        if (teamFieldsObserverRetryTimer || teamFieldsObserverRetryCount >= 40) return;
        teamFieldsObserverRetryCount += 1;
        teamFieldsObserverRetryTimer = setTimeout(function () {
          teamFieldsObserverRetryTimer = 0;
          initTeamFieldsSyncObserver();
        }, 250);
        return;
      }

      if (teamFieldsObserverRetryTimer) {
        clearTimeout(teamFieldsObserverRetryTimer);
        teamFieldsObserverRetryTimer = 0;
      }
      teamFieldsObserverRetryCount = 0;

      if (teamFieldsObserver && teamFieldsObservedForm === form) return;

      if (teamFieldsObserver) teamFieldsObserver.disconnect();
      teamFieldsObserver = new MutationObserver(function (mutations) {
        if (
          mutationTouchesWatchedSelectors(mutations || [], [
            "input[name^='properties[']",
            "select[name^='properties[']",
            "textarea[name^='properties[']",
            "input[name^='name_']",
            "input[name^='Name_']",
            "textarea[name^='name_']",
            "textarea[name^='Name_']",
            "input[name='quantity']",
            "quantity-input input",
            ".quantity__input",
            "input[data-nlb-prop]",
            "input[data-mlb-live]",
            "input[data-mlb-prop]"
          ])
        ) {
          scheduleUpdate(config.debounceMs.choice);
        }
      });

      teamFieldsObserver.observe(form, { childList: true, subtree: true });
      teamFieldsObservedForm = form;
    }

    function initPreviewClickthrough() {
      if (previewLinkBtn) {
        previewLinkBtn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          openClickthroughUrl(clickRuntime.url, clickRuntime.newTab);
        });
      }

      if (!previewCard) return;

      previewCard.addEventListener("pointerdown", function (event) {
        if (!clickRuntime.clickableCard || isInteractiveTarget(event.target)) {
          clickRuntime.pointerActive = false;
          return;
        }
        clickRuntime.pointerActive = true;
        clickRuntime.pointerMoved = false;
        clickRuntime.startX = Number(event.clientX || 0);
        clickRuntime.startY = Number(event.clientY || 0);
      }, { passive: true });

      previewCard.addEventListener("pointermove", function (event) {
        if (!clickRuntime.pointerActive) return;
        var x = Number(event.clientX || 0);
        var y = Number(event.clientY || 0);
        if (Math.abs(x - clickRuntime.startX) > 8 || Math.abs(y - clickRuntime.startY) > 8) {
          clickRuntime.pointerMoved = true;
        }
      }, { passive: true });

      previewCard.addEventListener("pointerup", function (event) {
        if (typeof event.button === "number" && event.button !== 0) {
          clickRuntime.pointerActive = false;
          return;
        }
        if (!clickRuntime.pointerActive) return;
        var shouldOpen = !clickRuntime.pointerMoved && !isInteractiveTarget(event.target);
        clickRuntime.pointerActive = false;
        if (!shouldOpen) return;
        openClickthroughUrl(clickRuntime.url, clickRuntime.newTab);
      });

      previewCard.addEventListener("pointercancel", function () {
        clickRuntime.pointerActive = false;
      });
    }

    // The 3D server sends the file encrypted (AES-CTR, a key per link): decrypted here, in memory only.
    function decryptModel(buffer, hexKey) {
      var bytes = new Uint8Array(32);
      for (var i = 0; i < 32; i++) bytes[i] = parseInt(hexKey.substr(i * 2, 2), 16);
      return crypto.subtle
        .importKey("raw", bytes.slice(0, 16), { name: "AES-CTR" }, false, ["decrypt"])
        .then(function (key) {
          return crypto.subtle.decrypt({ name: "AES-CTR", counter: bytes.slice(16), length: 64 }, key, buffer);
        });
    }

    function loadModelSrc(url, data) {
      var headers = {};
      if (String(url || "").indexOf(".ngrok-") !== -1) {
        headers["ngrok-skip-browser-warning"] = "true";
      }
      var hexKey = data && data.enc === MODEL_CIPHER && /^[0-9a-f]{64}$/.test(String(data.k || "")) ? data.k : "";

      return fetch(url, { headers: headers })
        .then(function (response) {
          if (!response.ok) throw new Error("Model download failed");
          if (!hexKey) return response.blob();
          return response.arrayBuffer().then(function (buffer) {
            return decryptModel(buffer, hexKey);
          }).then(function (plain) {
            return new Blob([plain], { type: "model/gltf-binary" });
          });
        })
        .then(function (blob) {
          if (activeModelBlobUrl) URL.revokeObjectURL(activeModelBlobUrl);
          activeModelBlobUrl = URL.createObjectURL(blob);
          viewer.setAttribute("src", activeModelBlobUrl);
        });
    }

    function updatePreview() {
      var payload = buildPayload(config);
      payload = appendTeamNamesToPayload(payload);
      var fp = getFingerprint(payload);
      if (fp === lastAppliedFingerprint || fp === inFlightFingerprint) return;

      var isGeometryChange = !haveSameKeys(payload, lastGeometryPayload, collectGeometryKeys(payload));
      if (!isGeometryChange && viewerHasModel) {
        if (applyColorsToViewer(payload)) {
          lastAppliedFingerprint = fp;
          setStatus(i18n("colors_updated", "Colors updated."));
          return;
        }
      }

      inFlightFingerprint = fp;

      requestId += 1;
      var currentRequestId = requestId;
      if (activeController) activeController.abort();
      activeController = new AbortController();
      setStatus(i18n("generating", "Generating 3D preview..."));

      fetch(config.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true"
        },
        body: JSON.stringify(
          window.crypto && window.crypto.subtle ? Object.assign({}, payload, { enc: MODEL_CIPHER }) : payload
        ),
        signal: activeController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Preview API request failed");
          return response.json();
        })
        .then(function (data) {
          if (currentRequestId !== requestId) return;
          if (!data || !data.url) throw new Error("Preview API response missing url");
          return loadModelSrc(data.url, data).then(function () {
            if (currentRequestId !== requestId) return;
            lastGeometryPayload = clonePayload(payload);
            viewerHasModel = true;
            applyColorsToViewer(payload);
            lastAppliedFingerprint = fp;
            inFlightFingerprint = "";
            setStatus(i18n("generated", "Freshly generated."));
          });
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") return;
          if (inFlightFingerprint === fp) inFlightFingerprint = "";
          console.error("[Sportify3D Preview] update failed", error);
          setStatus(i18n("failed", "Preview failed."));
        });
    }

    applyUiSettings();
    initPreviewClickthrough();
    refreshUiRuntimeStateFromForm();
    initStickyFallback();
    maybeRefreshAdaptiveFraming(false, true);
    viewer.addEventListener("pointerdown", pauseLimitedAutoRotate, { passive: true });
    viewer.addEventListener("wheel", pauseLimitedAutoRotate, { passive: true });
    viewer.addEventListener("touchstart", pauseLimitedAutoRotate, { passive: true });

    function onFirstFormInteraction() {
      stopLimitedAutoRotate();
      var rotateCfg = (config.viewerFraming && config.viewerFraming.autoRotateLimited) || {};
      rotateCfg.enabled = false;
      document.removeEventListener("input", onFirstFormInteraction, true);
      document.removeEventListener("change", onFirstFormInteraction, true);
    }
    document.addEventListener("input", onFirstFormInteraction, true);
    document.addEventListener("change", onFirstFormInteraction, true);

    function getShareText() {
      var payload = lastGeometryPayload || {};
      var sport = String(payload.sport || "sport");
      var name = String(payload.name || "").trim();
      var teamNames = Array.isArray(payload.team_names) ? payload.team_names.filter(Boolean) : [];
      var defaultName = String(config.defaults && config.defaults.name || "PREVIEW").toUpperCase().trim();
      if (teamNames.length > 1) {
        return "Our team just designed custom " + sport + " jerseys with Jack N Elliot Studio! 🏆";
      }
      if (name && name !== defaultName) {
        return "Just designed my custom " + sport + " jersey with Jack N Elliot Studio! 🏆";
      }
      return "Check out this custom " + sport + " jersey from Jack N Elliot Studio!";
    }

    var sharePopoverEl = null;
    var sharePopoverVisible = false;

    function closeSharePopover() {
      if (sharePopoverEl) sharePopoverEl.classList.remove("sp3d-share-pop--open");
      sharePopoverVisible = false;
      document.removeEventListener("click", onClickOutsideSharePop, true);
    }

    function onClickOutsideSharePop(e) {
      if (sharePopoverEl && !sharePopoverEl.contains(e.target) && e.target !== shareBtn) {
        closeSharePopover();
      }
    }

    function buildSharePopover(url, text) {
      var wa = "https://wa.me/?text=" + encodeURIComponent(text + "\n" + url);
      var fb = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
      var tw = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url);

      var el = document.createElement("div");
      el.id = "sp3d-share-pop";
      el.innerHTML = [
        '<a class="sp3d-share-opt" href="' + wa + '" target="_blank" rel="noopener" data-sp-wa>',
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>',
        "WhatsApp</a>",
        '<a class="sp3d-share-opt" href="' + fb + '" target="_blank" rel="noopener" data-sp-fb>',
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="#1877F2" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
        "Facebook</a>",
        '<a class="sp3d-share-opt" href="' + tw + '" target="_blank" rel="noopener" data-sp-tw>',
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
        "X / Twitter</a>",
        '<button class="sp3d-share-opt" type="button" data-sp-copy>',
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
        "Copy link</button>"
      ].join("");

      var copyBtn = el.querySelector("[data-sp-copy]");
      copyBtn.addEventListener("click", function () {
        var done = function () {
          copyBtn.textContent = "✓ Copied!";
          setTimeout(function () { copyBtn.textContent = "Copy link"; }, 2000);
          closeSharePopover();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var tmp = document.createElement("input");
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand("copy"); } catch (_e) {}
          document.body.removeChild(tmp);
          done();
        }
      });

      return el;
    }

    function openSocialShare() {
      var url = window.location.href;
      var text = getShareText();

      if (navigator.share) {
        navigator.share({ title: "Jack N Elliot Studio", text: text, url: url }).catch(function () {});
        return;
      }

      if (sharePopoverVisible) {
        closeSharePopover();
        return;
      }

      if (!sharePopoverEl) {
        sharePopoverEl = buildSharePopover(url, text);
        var wrap = (shareBtn.closest && shareBtn.closest(".sp3d-viewer-wrap")) || shareBtn.parentElement;
        wrap.appendChild(sharePopoverEl);
      } else {
        var wa = sharePopoverEl.querySelector("[data-sp-wa]");
        var fb = sharePopoverEl.querySelector("[data-sp-fb]");
        var tw = sharePopoverEl.querySelector("[data-sp-tw]");
        if (wa) wa.href = "https://wa.me/?text=" + encodeURIComponent(text + "\n" + url);
        if (fb) fb.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
        if (tw) tw.href = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url);
      }

      sharePopoverEl.classList.add("sp3d-share-pop--open");
      sharePopoverVisible = true;
      setTimeout(function () {
        document.addEventListener("click", onClickOutsideSharePop, true);
      }, 0);
    }

    function buildMockupHtml(imgDataUrl, payload, productUrl) {
      var teamNames = Array.isArray(payload.team_names) ? payload.team_names.filter(Boolean) : [];
      var playerName = String(payload.name || "").trim();
      var sport = String(payload.sport || "Sport");
      var defaultName = String(config.defaults && config.defaults.name || "PREVIEW").toUpperCase().trim();

      var headline, tagline;
      if (teamNames.length > 1) {
        headline = teamNames.length + " PLAYERS · ONE TEAM";
        tagline = "Your whole team, all in one order. Don’t let your teammates down — lock in before it sells out.";
      } else if (playerName && playerName !== defaultName) {
        headline = playerName + " IS READY TO PLAY";
        tagline = "Personalized just for you. Built to stand out on every " + escHtml(sport.toLowerCase()) + " field.";
      } else {
        headline = "YOUR JERSEY AWAITS";
        tagline = "100% custom-made for your team. Every detail, exactly how you want it.";
      }

      var jerseyHtml = imgDataUrl
        ? '<div class="jersey-wrap"><img src="' + imgDataUrl + '" alt="Custom ' + escHtml(sport) + ' jersey"></div>'
        : '<div class="jersey-wrap"><div class="no-img">3D preview not available</div></div>';

      var playersHtml = "";
      if (teamNames.length > 0) {
        var shown = teamNames.slice(0, 14);
        var remaining = teamNames.length - shown.length;
        var chips = shown.map(function (n) {
          return '<span class="player-chip">' + escHtml(String(n)) + "</span>";
        }).join("");
        playersHtml = '<div class="players-section">'
          + '<div class="players-label">' + teamNames.length + " Players on this order</div>"
          + '<div class="players-grid">' + chips + "</div>"
          + (remaining > 0 ? '<div class="more-players">+' + remaining + " more players</div>" : "")
          + "</div>";
      }

      var css = [
        "* { box-sizing: border-box; margin: 0; padding: 0; }",
        "body { font-family: system-ui, -apple-system, sans-serif; background: #0b0f2a; min-height: 100vh; display: flex; flex-direction: column; align-items: center; padding: 24px 16px 48px; }",
        ".card { background: linear-gradient(160deg, #0d1535 0%, #152045 100%); border: 1px solid #2a3a6a; border-radius: 20px; max-width: 480px; width: 100%; padding: 28px 24px 32px; box-shadow: 0 24px 60px rgba(0,0,0,.5), 0 0 0 1px rgba(200,168,75,.15); }",
        ".logo { text-align: center; font-size: 11px; letter-spacing: 3px; color: #c8a84b; text-transform: uppercase; margin-bottom: 18px; opacity: .7; font-weight: 700; }",
        ".badge { display: flex; align-items: center; gap: 6px; background: rgba(200,168,75,.12); border: 1px solid rgba(200,168,75,.35); border-radius: 20px; padding: 5px 14px; font-size: 11px; font-weight: 700; letter-spacing: 2px; color: #c8a84b; text-transform: uppercase; margin: 0 auto 20px; width: fit-content; }",
        ".jersey-wrap { background: radial-gradient(circle at 50% 40%, #d7e5ff 0%, #c4d8f8 60%, #b8cef5 100%); border-radius: 14px; padding: 12px; margin-bottom: 22px; border: 1px solid #2d4675; }",
        ".jersey-wrap img { width: 100%; display: block; border-radius: 8px; }",
        ".no-img { height: 200px; display: flex; align-items: center; justify-content: center; color: #7a9fd4; font-size: 14px; }",
        ".headline { font-size: 26px; font-weight: 800; color: #f0f6ff; text-transform: uppercase; letter-spacing: .04em; text-align: center; line-height: 1.15; margin-bottom: 6px; }",
        ".sport-pill { text-align: center; margin-bottom: 16px; }",
        ".sport-pill span { background: rgba(100,150,255,.12); border: 1px solid rgba(100,150,255,.25); border-radius: 12px; padding: 3px 12px; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; color: #8ab0f0; text-transform: uppercase; }",
        ".tagline { text-align: center; font-size: 14px; line-height: 1.6; color: #8faad4; margin-bottom: 22px; padding: 0 8px; }",
        ".players-section { background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.08); border-radius: 10px; padding: 14px 16px; margin-bottom: 20px; }",
        ".players-label { font-size: 10px; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; color: #c8a84b; margin-bottom: 8px; }",
        ".players-grid { display: flex; flex-wrap: wrap; gap: 6px; }",
        ".player-chip { background: rgba(200,168,75,.1); border: 1px solid rgba(200,168,75,.22); border-radius: 6px; padding: 4px 10px; font-size: 12px; font-weight: 600; color: #e8d48a; text-transform: uppercase; letter-spacing: .5px; }",
        ".more-players { font-size: 11px; color: #6a8ab4; margin-top: 8px; }",
        ".cta-btn { display: block; background: linear-gradient(135deg, #c8a84b 0%, #e4c86e 50%, #c8a84b 100%); color: #0b0f2a; font-size: 17px; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase; text-align: center; text-decoration: none; padding: 16px 24px; border-radius: 12px; margin-bottom: 16px; box-shadow: 0 4px 20px rgba(200,168,75,.35); }",
        ".trust { display: flex; justify-content: center; gap: 16px; flex-wrap: wrap; margin-bottom: 24px; }",
        ".trust span { font-size: 11px; color: #5a7aaa; }",
        ".actions { display: flex; gap: 10px; justify-content: center; }",
        ".btn-sec { background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.15); color: #c9d9f5; padding: 10px 20px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; }",
        ".btn-sec:hover { background: rgba(255,255,255,.12); }",
        "@media print { body { background: #fff; padding: 0; } .card { background: #fff; border: 1px solid #dde; box-shadow: none; max-width: 100%; } .headline { color: #1a1f4e; } .tagline { color: #444; } .sport-pill span { color: #1a1f4e; border-color: #aac; background: #eef; } .badge { color: #b8942a; border-color: #b8942a; background: #fdf8ee; } .players-section { border-color: #dde; background: #fafafa; } .player-chip { color: #7a6020; border-color: #c8a84b; background: #fdf4dd; } .actions { display: none; } }"
      ].join("\n");

      return [
        "<!DOCTYPE html>",
        '<html lang="en">',
        "<head>",
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1.0">',
        "<title>Your Team Mockup · Jack N Elliot Studio</title>",
        "<style>" + css + "</style>",
        "</head>",
        "<body>",
        '<div class="card">',
        '<div class="logo">Jack N Elliot Studio</div>',
        '<div class="badge">🏆 Your Team’s Mockup</div>',
        jerseyHtml,
        '<h1 class="headline">' + escHtml(headline) + "</h1>",
        '<div class="sport-pill"><span>' + escHtml(sport) + "</span></div>",
        '<p class="tagline">' + tagline + "</p>",
        playersHtml,
        '<a href="' + escHtml(productUrl) + '" class="cta-btn">Order for My Team →</a>',
        '<div class="trust"><span>✓ 100% Custom</span><span>✓ Fast Delivery</span><span>✓ Satisfaction Guaranteed</span></div>',
        '<div class="actions">',
        '<button class="btn-sec" onclick="window.print()">🖨️ Print</button>',
        '<button class="btn-sec" onclick="window.close()">Close</button>',
        "</div>",
        "</div>",
        "</body>",
        "</html>"
      ].join("\n");
    }

    function openShareMockup() {
      if (!viewerHasModel) return;
      var payload = lastGeometryPayload || {};
      var productUrl = String(window.location.href);
      shareBtn.disabled = true;

      function openMockupWindow(html) {
        var w = window.open("", "_blank", "noopener");
        if (w) { w.document.write(html); w.document.close(); }
      }

      function doOpen(imgDataUrl) {
        shareBtn.disabled = false;
        var html = buildMockupHtml(imgDataUrl, payload, productUrl);

        if (imgDataUrl && navigator.share) {
          var sport = String(payload.sport || "Sport");
          var imgBlob = null;
          try {
            var byteStr = atob(imgDataUrl.split(",")[1]);
            var arr = new Uint8Array(byteStr.length);
            for (var i = 0; i < byteStr.length; i++) arr[i] = byteStr.charCodeAt(i);
            imgBlob = new Blob([arr], { type: "image/png" });
          } catch (_e) {}
          if (imgBlob) {
            var file = new File([imgBlob], "jack-n-elliot-mockup.png", { type: "image/png" });
            var shareData = { title: "Custom " + sport + " Jersey – Jack N Elliot Studio", text: "Check out our team’s custom jersey!", files: [file], url: productUrl };
            var canShare = false;
            try { canShare = !!(navigator.canShare && navigator.canShare(shareData)); } catch (_e) {}
            if (canShare) {
              navigator.share(shareData).catch(function () { openMockupWindow(html); });
              return;
            }
          }
        }
        openMockupWindow(html);
      }

      if (viewer && typeof viewer.toBlob === "function") {
        viewer.toBlob({ idealAspect: true }).then(function (blob) {
          if (!blob) { doOpen(null); return; }
          var reader = new FileReader();
          reader.onloadend = function () { doOpen(String(reader.result)); };
          reader.onerror = function () { doOpen(null); };
          reader.readAsDataURL(blob);
        }).catch(function () { doOpen(null); });
      } else {
        doOpen(null);
      }
    }

    if (shareBtn) {
      shareBtn.addEventListener("click", openSocialShare);
    }

    var rotateHintShown = false;
    if (rotateHintEl) {
      viewer.addEventListener("pointerdown", function () {
        rotateHintEl.classList.remove("sp3d-rotate-hint--visible");
      }, { passive: true });
    }

    viewer.addEventListener("load", function () {
      viewerHasModel = true;
      if (rotateHintEl && !rotateHintShown) {
        rotateHintShown = true;
        rotateHintEl.classList.add("sp3d-rotate-hint--visible");
        setTimeout(function () { rotateHintEl.classList.remove("sp3d-rotate-hint--visible"); }, 3000);
      }
      maybeRefreshAdaptiveFraming(true, true);
      refreshViewerWindowSize();
      if (stickyFallbackHandle && typeof stickyFallbackHandle.refresh === "function") {
        stickyFallbackHandle.refresh();
      }
      if (lastGeometryPayload) applyColorsToViewer(lastGeometryPayload);
    });

    window.addEventListener("resize", function () {
      maybeRefreshAdaptiveFraming(false, true);
      refreshViewerWindowSize();
      if (stickyFallbackHandle && typeof stickyFallbackHandle.refresh === "function") {
        stickyFallbackHandle.refresh();
      }
    });

    function handleFieldEvent(event) {
      var target = event && event.target;
      var isTeamField = isTeamPreviewTrackedField(target);
      var isVariantField = isVariantSelectorField(target);
      var isPropField = isPropertyField(target);
      var isQtyField = isQuantityField(target);
      if (!isTeamField && !isVariantField && !isPropField && !isQtyField && !matchesAnySelector(target, watchedSelectors)) return;
      refreshUiRuntimeStateFromForm();
      var isText = target && target.matches && target.matches("input[type='text'], textarea");
      scheduleUpdate(isText ? config.debounceMs.text : config.debounceMs.choice);
    }

    if (config.autoUpdate !== false) {
      var events = config.autoUpdateEvents || {};
      if (events.input !== false) document.addEventListener("input", handleFieldEvent, true);
      if (events.change !== false) document.addEventListener("change", handleFieldEvent, true);
      if (events.click === true) document.addEventListener("click", handleFieldEvent, true);
    }

    if (button) {
      button.addEventListener("click", function () {
        scheduleUpdate(0);
      });
    }

    if (addToCartBtn) {
      initAddToCartButtonSync();
      addToCartBtn.addEventListener("click", function () {
        syncAddToCartButtonTheme();
        var form = findAddToCartForm();
        if (!form) {
          setStatus("Product form not found.");
          return;
        }
        var submitBtn = findAddSubmitButton(form);
        if (submitBtn && typeof submitBtn.click === "function") {
          submitBtn.click();
          return;
        }
        setStatus("Add to cart unavailable.");
      });
    }

    initTeamFieldsSyncObserver();

    if (config.observeDom && window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        refreshTeamPreviewOptionNames();
        if (
          mutationTouchesWatchedSelectors(mutations || [], watchedSelectors) ||
          mutationTouchesWatchedSelectors(mutations || [], [
            "input[name^='properties[']",
            "select[name^='properties[']",
            "textarea[name^='properties[']",
            "input[name^='name_']",
            "input[name^='Name_']",
            "textarea[name^='name_']",
            "textarea[name^='Name_']",
            "input[name='quantity']",
            "quantity-input input",
            ".quantity__input",
            "input[data-mlb-live]",
            "input[data-mlb-prop]"
          ])
        ) {
          scheduleUpdate(config.debounceMs.choice);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    refreshTeamPreviewOptionNames();

    if (typeof config.initialDelayMs === "number" && config.initialDelayMs > 0) {
      setTimeout(updatePreview, config.initialDelayMs);
    } else {
      updatePreview();
    }
  }

  function boot() {
    resolveBootstrapConfig()
      .then(function (runtimeConfig) {
        install(runtimeConfig);
      })
      .catch(function (error) {
        console.error("[Sportify3D Preview] boot failed, fallback to default config", error);
        install(DEFAULT_CONFIG);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
